// generated by stuff/i18n.py. DO NOT EDIT.
const translations: { [key: string]: string; } = {
  U13CannotPerform: "Coder menor de 13 a\u00f1os no puede realizar esta acci\u00f3n.",
  aboutToStart: "Est\u00e1s a punto de iniciar el concurso. Una vez que hagas clic en entrar, tu tiempo iniciar\u00e1.",
  acceptPrivacyPolicy: "He le\u00eddo y acepto la [Pol\u00edtica de Uso y Privacidad](%(PrivacyPolicyURL)) del sitio, as\u00ed como el [C\u00f3digo de Conducta](%(CodeofConductPolicyURL)).",
  accountDeleteCancel: "Cancelar",
  accountDeleteConfirmationMessage: "\u00bfEst\u00e1s segura de que quieres eliminar tu cuenta?",
  accountDeleteMessage: "Haga clic en el siguiente bot\u00f3n si desea eliminar su cuenta y toda su informaci\u00f3n personal de omegaUp. Esta operaci\u00f3n se realizar\u00e1 inmediatamente despu\u00e9s de que confirmes que quieres realizarla y no es reversible.",
  accountDeleteOk: "Eliminar",
  accountDeleteRequireConfirmation: "Confirmaci\u00f3n Requerida",
  accountDeletionConfirmEmailBody: "%(username) confirm\u00f3 eliminar su cuenta.",
  accountDeletionConfirmEmailSubject: "Confirmaci\u00f3n de eliminaci\u00f3n de cuenta omegaUp.",
  accountDeletionRequestEmailBody: "%(username) ha solicitado borrar su cuenta.",
  accountDeletionRequestEmailSubject: "Solicitud de eliminaci\u00f3n de cuenta omegaUp",
  activityReport: "Reporte de actividades",
  activityReportDuplicatesForOriginsDescription: "Or\u00edgenes con m\u00e1s de una cuenta",
  activityReportDuplicatesForUsersDescription: "Cuentas con m\u00e1s de una direcci\u00f3n",
  activityReportEvent: "Evento",
  activityReportNoDuplicatesForOrigins: "No hay or\u00edgenes con m\u00e1s de una cuenta",
  activityReportNoDuplicatesForUsers: "No hay cuentas con m\u00e1s de una direcci\u00f3n",
  activityReportOrigin: "Direcci\u00f3n de origen",
  activityReportOrigins: "Or\u00edgenes",
  activityReportReport: "Reporte",
  activityReportSummaryContest: "Este es el reporte de actividades que ocurrieron durante el concurso. Para proteger la privacidad de los concursantes, sus direcciones IP han sido ofuscadas utilizando un hash perfecto. Esto quiere decir que hay una correspondencia uno-a-uno entre direcciones IP y los ID de origen.",
  activityReportSummaryCourse: "Este es el reporte de actividades que ocurrieron durante el curso. Para proteger la privacidad de los participantes, sus direcciones IP han sido ofuscadas utilizando un hash perfecto. Esto quiere decir que hay una correspondencia uno-a-uno entre direcciones IP y los ID de origen.",
  activityReportUsers: "Nombre de la cuenta",
  addContestUsernameAndPassword: "Si participaste en alg\u00fan concurso y te asignaron una nueva cuenta, agr\u00e9gala aqu\u00ed para vincularla con tu cuenta principal.",
  addUsersMultipleOrSingleUser: "Agregar una o m\u00faltiples cuentas",
  addUsersToReviewerGroup: "Clic para agregar una cuenta a la lista de revisores.",
  adminAdded: "Administrador agregado correctamente",
  adminRemoved: "Administrador eliminado correctamente",
  adminSupportEmailUpdatedSuccessfully: "El correo electr\u00f3nico se actualiz\u00f3 correctamente",
  adminSupportPageNotFound: "P\u00e1gina no encontrada",
  adminSupportTypeNewEmail: "Escribe el nuevo correo electr\u00f3nico",
  admissionModeManualOnly: "Manual (Agrega los nombres de las cuentas de tus estudiantes)",
  admissionModePublic: "P\u00fablico (Los estudiantes se inscriben con la liga al curso)",
  admissionModeShareURL: "Compartir URL (Los estudiantes se inscriben desde el URL)",
  aliasAlreadyInUse: "El alias \"%(alias)\" ya est\u00e1 siendo usado. Por favor elige un nombre distinto.",
  aliasInUse: "El alias (t\u00edtulo corto) ya est\u00e1 siendo usado. Por favor elige un alias distinto.",
  allowedSolutionsLimitReached: "Has alcanzado el l\u00edmite de soluciones permitidas",
  apiNotFound: "El API solicitada no fue encontrada.",
  apiTokenAdd: "Agregar token de API",
  apiTokenDescription: "Si quieres usar la API de omegaup, puedes crear un token de API, cada token puede hacer hasta 1000 peticiones por hora y puedes tener hasta 5 tokens de API.",
  apiTokenLastTimeUsed: "'\u00daltima vez usado",
  apiTokenLimit: "L\u00edmite",
  apiTokenLimitExceeded: "N\u00famero m\u00e1ximo de tokens de API excedido.",
  apiTokenName: "Nombre del token",
  apiTokenNameAlreadyInUse: "Los nombres de los tokens deben ser \u00fanicos",
  apiTokenRateLimitExceeded: "L\u00edmite de peticiones al API excedido. Por favor intenta de nuevo m\u00e1s tarde.",
  apiTokenRemaining: "Peticiones restantes",
  apiTokenResetTime: "Tiempo de reinicio",
  apiTokenRevoke: "Revocar API token",
  apiTokenSuccessfullyCreated: "Token creado con \u00e9xito, copie el token ya que s\u00f3lo se mostrar\u00e1 una vez: %(token)",
  apiTokenSuccessfullyRevoked: "Token revocado exitosamente",
  apiTokenTimestamp: "Marca de tiempo",
  arbitrateRequestAcceptSuccessfully: "La solicitud ha sido aprobada satisfactoriamente",
  arbitrateRequestDenySuccessfully: "La solicitud ha sido denegada satisfactoriamente",
  arenaClarificationCreate: "Escribe tu pregunta aqu\u00ed:",
  arenaClarificationMaxLength: "M\u00e1ximo 200 caracteres, no incluyas tu c\u00f3digo completo.",
  arenaCommonCode: "C\u00f3digo",
  arenaCommonMemoryLimit: "L\u00edmite de memoria",
  arenaCommonOverallWallTimeLimit: "L\u00edmite de tiempo (total)",
  arenaCommonTimeLimit: "L\u00edmite de tiempo (caso)",
  arenaContestEndedUsePractice: "Este concurso ha terminado. Para continuar enviando soluciones usa nuestro Modo Pr\u00e1ctica haciendo clic aqu\u00ed.",
  arenaContestHasAlreadyStarted: "Este concurso ha comenzado",
  arenaContestNotOpened: "Necesitas abrir el concurso como no-administrador para hacer env\u00edos.",
  arenaContestOrganizer: "Organiza",
  arenaContestPracticeOriginalRunsText: "Para ver los env\u00edos del concurso, da clic [aqu\u00ed](/arena/%(contestAlias)/#runs)",
  arenaContestPracticeOriginalScoreboardText: "Para ver el scoreboard original, da clic [aqu\u00ed](/arena/%(contestAlias)/#ranking)",
  arenaContestWindowLength: "Tiempo para resolver los problemas",
  arenaCourseAllContent: "Todo el contenido",
  arenaCourseAssignmentHasAlreadyStarted: "Este contenido ya inici\u00f3",
  arenaCourseAssignmentWillBeginIn: "Este contenido iniciar\u00e1 en %(time)",
  arenaCourseProblemTitle: "%(letter). %(title)",
  arenaPageRecommendedContestsText: "Para mostrar tu concurso en la lista de Concursos Recomendados, contacta a soporte@omegaup.com.",
  arenaPageTitle: "omegaUp Arena",
  arenaPracticeEndtime: "Hora de fin",
  arenaPracticeScoreboardCutoff: "Fin de actualizaci\u00f3n del scoreboard",
  arenaPracticeStartTime: "Hora de inicio",
  arenaRunSubmitEmptyCode: "No se puede enviar c\u00f3digo vac\u00edo",
  arenaRunSubmitFilename: "Tu c\u00f3digo se guardar\u00e1 en el archivo: ",
  arenaRunSubmitFilesize: "El l\u00edmite para subir archivos son %(limit)",
  arenaRunSubmitMissingLanguage: "Debes elegir un lenguaje",
  arenaRunSubmitPaste: "Pega el c\u00f3digo de tu programa aqu\u00ed",
  arenaRunSubmitUpload: "O sube un archivo",
  arenaRunSubmitWaitBetweenUploads: "Tienes que esperar %(submissionGap) segundos antes de que puedas hacer otro env\u00edo a este problema",
  arenaRunsActions: "Acciones",
  arenaRunsActionsDetails: "Detalles",
  arenaRunsActionsDisqualified: "Descalificado",
  arenaRunsActionsDisqualifyByGUID: "Descalificar env\u00edo",
  arenaRunsActionsDisqualifyByProblem: "Descalificar todos los env\u00edos del usuario para este problema",
  arenaRunsActionsDisqualifyByUser: "Descalificar todos los env\u00edos del usuario para este concurso",
  arenaRunsActionsRejudge: "Rejuecear",
  arenaRunsActionsRequalify: "Recalificar",
  arrayEditTitle: "Editor de array",
  arrayModalBack: "Atr\u00e1s",
  arrayModalDistinctValues: "Valores distintos",
  arrayModalGenerate: "Generar",
  arrayModalGeneratedArray: "Array generado",
  arrayModalMaximum: "M\u00e1ximo",
  arrayModalMinimum: "M\u00ednimo",
  arrayModalSave: "Guardar",
  arrayModalSize: "Tama\u00f1o",
  assignmentCardLessons: "%(lessonCount) lecciones",
  assignmentCardProblems: "%(problemCount) problemas",
  assignmentCardStart: "Iniciar",
  assignmentNotFound: "No se encontr\u00f3 el contenido",
  assignmentNotStarted: "La lecci\u00f3n a\u00fan no ha comenzado",
  assignmentRemoveAlreadyHasRuns: "No se puede eliminar contenido si ya tiene soluciones revisadas.",
  authorRankRangeHeader: "Contribuidores con mayor puntaje (%(lowCount) a %(highCount))",
  authorRankUnranked: "Autor no clasificado",
  badgeAssignationTimeMessage: "Fecha en que conseguiste esta insignia",
  badgeFirstAssignationMessage: "La primera vez que esta insignia fue asignada",
  badgeNotAssignedMessage: "A\u00fan no has conseguido esta insignia",
  badgeNotExist: "La insignia no existe.",
  badgeOwnersMessage: "Coders que han recibido esta insignia",
  badge_100solvedProblems_description: "Otorgado a personas que han resuelto 100 problemas o m\u00e1s.",
  badge_100solvedProblems_name: "100 Problemas resueltos",
  badge_15dayStreak_description: "Otorgado a personas que han mantenido una racha de 15 d\u00edas consecutivos.",
  badge_15dayStreak_name: "Racha de 15 d\u00edas",
  badge_30dayStreak_description: "Otorgado a personas que han mantenido una racha de 30 d\u00edas consecutivos.",
  badge_30dayStreak_name: "Racha de 30 d\u00edas",
  badge_500score_description: "Otorgado a personas que han conseguido una puntuaci\u00f3n igual o mayor que 500.",
  badge_500score_name: "Puntuaci\u00f3n 500",
  badge_7dayStreak_description: "Otorgado a personas que han mantenido una racha de 7 d\u00edas consecutivos.",
  badge_7dayStreak_name: "Racha de 7 d\u00edas",
  badge_christmasProblem2021_description: "Otorgado a personas que participaron en el Concurso Un Problema para Navidad 2021 enviando problemas originales con tem\u00e1tica Navidad.",
  badge_christmasProblem2021_name: "Problema para navidad 2021",
  badge_coderOfTheMonth_description: "Otorgado a personas que han sido nombradas Coder del Mes al menos una vez.",
  badge_coderOfTheMonth_name: "Coder del Mes",
  badge_contestManager_description: "Otorgado a personas que han administrado al menos un concurso.",
  badge_contestManager_name: "Admin de Concurso",
  badge_cppCourseGraduate_description: "Otorgado a personas que han resuelto m\u00e1s del 60% del curso de Introducci\u00f3n a C++.",
  badge_cppCourseGraduate_name: "Aprob\u00f3 el curso de Introducci\u00f3n a C++",
  badge_cppExpert_description: "Otorgado a personas que han resuelto m\u00e1s de 10 problemas en C++.",
  badge_cppExpert_name: "Especialista en C++",
  badge_feedbackProvider_description: "Otorgado a personas que han enviado la calificaci\u00f3n de al menos un problema.",
  badge_feedbackProvider_name: "Proveedor de Feedback",
  badge_introToAlgorithms2CourseGraduate_description: "Otorgado a personas que han resuelto m\u00e1s del 70% del curso de Introducci\u00f3n a Algoritmos II.",
  badge_introToAlgorithms2CourseGraduate_name: "Aprob\u00f3 el curso de Introducci\u00f3n a Algoritmos II",
  badge_introToAlgorithmsCourseGraduate_description: "Otorgado a personas que han resuelto m\u00e1s del 70% del curso de Introducci\u00f3n a Algoritmos I.",
  badge_introToAlgorithmsCourseGraduate_name: "Aprob\u00f3 el curso de Introducci\u00f3n a Algoritmos I",
  badge_javaExpert_description: "Otorgado a personas que han resuelto m\u00e1s de 10 problemas en Java.",
  badge_javaExpert_name: "Especialista en Java",
  badge_karelExpert_description: "Otorgado a personas que han resuelto m\u00e1s de 10 problemas en Karel.",
  badge_karelExpert_name: "Especialista en Karel",
  badge_legacyUser_description: "Otorgado a personas que realizaron alg\u00fan env\u00edo hace m\u00e1s de 3 a\u00f1os.",
  badge_legacyUser_name: "Trayectoria Hist\u00f3rica",
  badge_pascalExpert_description: "Otorgado a personas que han resuelto m\u00e1s de 10 problemas en Pascal.",
  badge_pascalExpert_name: "Especialista en Pascal",
  badge_problemOfTheWeekWithOmegaUp_description: "Otorgado a personas que han resuelto un problema del curso de Resolviendo Problemas en omegaUp.",
  badge_problemOfTheWeekWithOmegaUp_name: "Problema de la semana con omegaUp",
  badge_problemSetter_description: "Otorgado a personas que han creado al menos un problema.",
  badge_problemSetter_name: "Creador de Problemas",
  badge_pythonCourseGraduate_description: "Otorgado a personas que han resuelto m\u00e1s del 90% del curso de Introducci\u00f3n a Python.",
  badge_pythonCourseGraduate_name: "Aprob\u00f3 el curso de Introducci\u00f3n a Python",
  badge_pythonExpert_description: "Otorgado a personas que han resuelto m\u00e1s de 10 problemas en Python.",
  badge_pythonExpert_name: "Especialista en Python",
  badge_updatedUser_description: "Otorgado a personas que han completado la informaci\u00f3n en su perfil.",
  badge_updatedUser_name: "Perfil Actualizado",
  badge_virtualContestManager_description: "Otorgado a personas que han administrado al menos un concurso virtual.",
  badge_virtualContestManager_name: "Admin de Concurso Virtual",
  banProblemFormComments: "Comentarios adicionales para el creador del problema",
  banProblemFormQuestion: "\u00bfPor qu\u00e9 se suspender\u00e1 este problema?",
  bannerLastDayToVerifyAccount: "\u00a1Atenci\u00f3n! Solo queda 1 d\u00eda para que tu padre o tutor apruebe tu cuenta. De lo contrario, tu cuenta ser\u00e1 eliminada.",
  bannerVerifyAccount: "Es necesario que tu padre o tutor apruebe tu cuenta en un plazo de %(days) d\u00edas. De lo contrario, tu cuenta ser\u00e1 eliminada.",
  banningDeclinedByReviewer: "Suspensi\u00f3n denegada por juez.",
  banningProblemDueToReport: "Suspendiendo problema por reporte de una cuenta.",
  birthdayInTheFuture: "No tienes edad suficiente para usar omegaUp",
  bulkOperationError: "Hubo un error al ejecutar la operaci\u00f3n",
  bulkUserAddError: "Se produjo un error al agregar las cuentas. Los siguientes nombres o correos electr\u00f3nicos no se encontraron en omegaUp:<br><br><b>%(userEmail)</b>.<br><br>Sin embargo, el resto de cuentas se han agregado correctamente.",
  bulkUserAddSuccess: "Cuentas exitosamente agregadas.",
  buttonCreateContest: "Crear un concurso",
  buttonCreateProblem: "Crear un problema",
  buttonGoToContests: "Ir a concursos",
  buttonGoToCourses: "Ir a cursos",
  buttonGoToProblems: "Ir a problemas",
  cannotAddProb: "No puedes agregar problemas porque no eres el director del concurso.",
  cannotRemoveProblem: "No puedes eliminar problemas porque no eres el director del concurso.",
  cannotRemoveProblemWithSubmissions: "No puedes eliminar un problema que ya tiene env\u00edos",
  caseEditTitle: "Editar caso",
  caseModalBack: "Atr\u00e1s",
  caseModalSave: "Guardar",
  certificateDetailsBody: "Favor de escribirnos a [certificates@omegaup.com](mailto:certificates@omegaup.com?subject=Validar%20diploma%20%(uuid)) para verificar el diploma. Incluye el ID del diploma (%(uuid)) en el asunto del correo.",
  certificateDetailsTitle: "Proceso de verificaci\u00f3n de diplomas",
  certificateListMineActions: "Acciones",
  certificateListMineCertificatesEmpty: "No hay diplomas",
  certificateListMineCoderOfTheMonth: "Coder del mes",
  certificateListMineCoderOfTheMonthFemale: "Coder del mes para ellas",
  certificateListMineContest: "Concurso \"%(contest_title)\"",
  certificateListMineCopyToClipboard: "Copiar liga de verificaci\u00f3n",
  certificateListMineCourse: "Curso \"%(course_name)\"",
  certificateListMineDate: "Fecha",
  certificateListMineDownload: "Descargar diploma",
  certificateListMineFileDownloaded: "El diploma se ha descargado",
  certificateListMineLinkCopiedToClipboard: "La liga de verificaci\u00f3n fue copiada",
  certificateListMineReason: "Raz\u00f3n",
  certificateListMineTitle: "Mis Diplomas",
  certificateListMineVerificationLink: "Liga de verificaci\u00f3n",
  certificateNotFound: "Diploma no encontrado",
  certificatePdfCoderOfTheMonthDescription: "por su desempe\u00f1o en el mes de %(month_name) al obtener m\u00e1s puntos en la plataforma omegaUp.com",
  certificatePdfCoderOfTheMonthFemaleTitle: "Coder del mes para ellas",
  certificatePdfCoderOfTheMonthTitle: "Coder del mes",
  certificatePdfContestDescription: "por su participaci\u00f3n en el concurso \"%(contest_title)\" que se llev\u00f3 a cabo en la plataforma omegaUp.com",
  certificatePdfContestParticipation: "Participaci\u00f3n",
  certificatePdfContestPlaceNd: "\u00b0 lugar",
  certificatePdfContestPlaceRd: "\u00b0 lugar",
  certificatePdfContestPlaceSt: "\u00b0 lugar",
  certificatePdfContestPlaceTh: "\u00b0 lugar",
  certificatePdfCourseDescription: "por completar el curso \"%(course_name)\" en la plataforma omegaUp.com",
  certificatePdfCourseTitle: "Graduaci\u00f3n",
  certificatePdfDirector: "Director Ejecutivo",
  certificatePdfGrantsRecognition: "Otorga el reconocimiento de",
  certificatePdfHeader: "Incrementando el n\u00famero de ingenieros de software talentosos en Am\u00e9rica Latina",
  certificatePdfMonth1: "Enero",
  certificatePdfMonth10: "Octubre",
  certificatePdfMonth11: "Noviembre",
  certificatePdfMonth12: "Diciembre",
  certificatePdfMonth2: "Febrero",
  certificatePdfMonth3: "Marzo",
  certificatePdfMonth4: "Abril",
  certificatePdfMonth5: "Mayo",
  certificatePdfMonth6: "Junio",
  certificatePdfMonth7: "Julio",
  certificatePdfMonth8: "Agosto",
  certificatePdfMonth9: "Septiembre",
  certificatePdfPerson: "a la persona",
  certificatePdfPlaceAndDate: "Bellevue, Washington a %(day) de %(month) de %(year)",
  certificatePdfVerificationCode: "C\u00f3digo de verificaci\u00f3n: %(verification_code)",
  certificatePdfVerificationLink: "Liga de verificaci\u00f3n: https://omegaup.com/cert/%(verification_code)/",
  certificateValidationCertifyValidity: "omegaUp certifica la validez del siguiente diploma",
  certificateValidationEnteredCode: "C\u00f3digo ingresado: ",
  certificateValidationInvalid: "Inv\u00e1lido",
  certificateValidationNotFound1: "No se encontr\u00f3 ning\u00fan diploma con el c\u00f3digo ",
  certificateValidationNotFound2: " en la base de datos. Si usted cree que eso es un error por favor cont\u00e1ctenos en hello@omegaup.com.",
  certificateValidationStatus: "Estado: ",
  certificateValidationTitle: "Verificar Diploma",
  clarificationContest: "Concurso:",
  clarificationEmailBody: "<p>\u00a1Hola!</p><p><strong><a href=\"https://omegaup.com/profile/%(user_name)\">%(user_name)</a></strong> solicit\u00f3 una clarificaci\u00f3n para el problema <strong><a href=\"https://omegaup.com/arena/problem/%(problem_alias)\">%(problem_name)</a></strong>:</p><p><blockquote><p>%(clarification_body)</p></blockquote><p>Para responder, por favor visita esta liga: <a href=\"%(url)\">%(url)</a>.</p><p>Gracias,<br/>omegaUp</p>",
  clarificationEmailSubject: "[omegaUp] Nueva clarificaci\u00f3n para el problema %(problem_name)",
  clarificationHomework: "Tarea:",
  clarificationInfo: "Info",
  clarificationNotFound: "Clarificaci\u00f3n no encontrada",
  clarificationProblem: "Problema:",
  clarificationTime: "Fecha y hora:",
  clarificationUpdateAnswer: "Actualizar respuesta",
  clarificationsAskedBy: "Preguntado por:",
  clarificationsEmpty: "A\u00fan no hay clarificaciones",
  clarificationsOnBehalf: "%(author) (a nombre de %(receiver))",
  clarificationsRangeHeader: "Clarificaciones (del %(lowCount) al %(highCount))",
  coderOfTheMonth: "Coder del Mes General",
  coderOfTheMonthAlreadySelected: "El coder del mes ya ha sido seleccionado con anterioridad",
  coderOfTheMonthCanBeChosenManually: "Recuerda que puedes elegir a las personas ganadoras de Coder del mes para ambas categor\u00edas en la secci\u00f3n de [Coder del mes](https://omegaup.com/coderofthemonth/) y [Coder del mes para ellas](https://omegaup.com/coderofthemonth/female/).",
  coderOfTheMonthChooseAsCoder: "Elegir como coder del mes",
  coderOfTheMonthFemale: "Coder del Mes para Ellas",
  coderOfTheMonthFemaleChooseAsCoder: "Elegir como la coder del mes",
  coderOfTheMonthFemaleSelectedSuccessfully: "La coder del mes ha sido seleccionada satisfactoriamente.",
  coderOfTheMonthFullList: "Ver listado completo",
  coderOfTheMonthIsNotInPeriodToBeChosen: "Coder del mes no est\u00e1 en periodo de ser elegido",
  coderOfTheMonthNotFound: "No se encontr\u00f3 coder del mes.",
  coderOfTheMonthNotice: "\u00a1Hola %(username)! \u00a1Felicidades por ganar el reconocimiento al Coder del Mes!",
  coderOfTheMonthSelectedSuccessfully: "Coder del mes ha sido seleccionado satisfactoriamente.",
  coderOfTheMonthSystemInMaintainance: "El sistema de Coder del Mes se encuentra en mantenimiento.\n\nVolveremos pronto.",
  codersOfTheMonth: "Coders del Mes",
  codersOfTheMonthCountry: "Pa\u00eds / Regi\u00f3n",
  codersOfTheMonthDate: "Fecha",
  codersOfTheMonthFemale: "Las Coders del Mes",
  codersOfTheMonthFemaleListCandidate: "Lista de candidatas para la coder del mes",
  codersOfTheMonthFemaleRank: "Las mejores 100 coders del mes pasado",
  codersOfTheMonthListCandidate: "Lista de aspirantes a coder del mes",
  codersOfTheMonthRank: "Top 100 coders del mes pasado",
  codersOfTheMonthUser: "Coder",
  collecionOtherTags: "Otras etiquetas",
  collectionTitle: "Colecciones de Problemas",
  contentCreator: "Contribuidor",
  contentOrderUpdated: "El orden del contenido se ha actualizado",
  contestAddUserContestant: "Concursante",
  contestAddgroupAddGroup: "Agregar grupo",
  contestAddlectureLectureName: "Lectura",
  contestAddlectureLecturePoints: "Puntos que vale la lectura",
  contestAddproblemChooseVersion: "Versi\u00f3n",
  contestAddproblemContestOrder: "Orden en el concurso",
  contestAddproblemLatestVersion: "\u00daltima versi\u00f3n",
  contestAddproblemOtherVersion: "Otra versi\u00f3n",
  contestAddproblemProblemName: "Problema",
  contestAddproblemProblemOrder: "Orden",
  contestAddproblemProblemPoints: "Puntos que vale el problema",
  contestAddproblemProblemRemove: "Quitar",
  contestAddproblemTooManyProblems: "Este concurso tiene demasiados problemas y no es posible agregar nuevos",
  contestAdduserAddContestant: "Concursantes",
  contestAdduserAddUsers: "Agregar cuentas",
  contestAdduserRegisteredUserDelete: "Eliminar",
  contestAdduserRegisteredUserTime: "Tiempo de primer acceso",
  contestAdmissionModeDescription: "Selecciona el modo de acceso del concurso. Existen tres modalidades distintas:\n\n- **Privado:** El concurso s\u00f3lo es visible para coders que hayan sido invitados expl\u00edcitamente.\n\n- **Registro/abierto:** Cualquier persona se puede registrar, s\u00f3lo tienen acceso las personas admitidas por admins.\n\n- **P\u00fablico:** Cualquier persona puede participar.",
  contestAndProblemPrintButtonDesc: "Imprimir",
  contestBasicInformationNeeded: "Para unirte al concurso debes completar tu informaci\u00f3n b\u00e1sica. Ir a [Mi perfil](/profile/#edit-basic-information)",
  contestButtonEnter: "Entrar",
  contestButtonScoreboard: "Scoreboard",
  contestButtonSeeDetails: "Ver detalles",
  contestCanNotChangeToContestForTeams: "Un concurso normal no se puede cambiar a concurso para equipos",
  contestCertificatesConfirmGenerate: "\u00bfEst\u00e1s seguro de que quieres generar los diplomas?, una vez que se generen los diplomas no se podr\u00e1n modificar. Aseg\u00farate de que el scoreboard est\u00e9 descongelado.",
  contestCertificatesCurrentContestError: "Los diplomas no pueden ser generados porque el concurso a\u00fan no termina.",
  contestCertificatesCutoff: "Corte para diplomas",
  contestCertificatesCutoffHelp: "El n\u00famero de concursantes en primeras posiciones a ser galardonados con diplomas especiales. El resto de concursantes recibir\u00e1n diplomas de participaci\u00f3n que no mencionan el lugar en que quedaron.",
  contestCertificatesError: "Hubo un error al generar los diplomas.",
  contestCertificatesGenerate: "Generar diplomas",
  contestCertificatesGenerateSuccessfully: "Diplomas generados exitosamente.",
  contestDetailsGoToContest: "Ir al concurso",
  contestDownloadListOfUsersInContest: "Descargar lista de coders en el concurso",
  contestDuration: "Duraci\u00f3n: %(duration)",
  contestEdit: "Editar",
  contestEditAddProblemSearchByAlias: "Alias",
  contestEditAddProblemSearchByAll: "Todo",
  contestEditAddProblemSearchById: "Id",
  contestEditAddProblemSearchByTitle: "T\u00edtulo",
  contestEditAddProblems: "Problemas",
  contestEditAdministrativeLinks: "Enlaces administrativos",
  contestEditArchive: "Archivar",
  contestEditArchiveConfirmText: "\u00bfEst\u00e1s seguro de que deseas realizar esta acci\u00f3n?",
  contestEditArchiveContest: "Archivar concurso",
  contestEditArchiveHelpText: "Al archivar un concurso, \u00e9ste dejar\u00e1 de aparecer en todos los listados. La \u00fanica forma de acceder al mismo, es a trav\u00e9s de su URL o desde el listado de \"Mis concursos\", en la pesta\u00f1a \"Concursos archivados\". Esta acci\u00f3n puede deshacerse.",
  contestEditArchivedSuccess: "Concurso archivado exitosamente.",
  contestEditCannotReplaceTeamsGroupWithSubmissions: "No puedes reemplazar un grupo de equipos en un concurso que ya tiene env\u00edos",
  contestEditCatLanguageAddedWarning: "Se agreg\u00f3 \"cat\" a los lenguajes del concurso porque el problema agregado lo requiere",
  contestEditCertificates: "Diplomas",
  contestEditContestClonedSuccessfully: "El concurso se clon\u00f3 exitosamente",
  contestEditContestEdited: "Tu concurso ha sido editado.",
  contestEditContestLinkCopiedToClipboard: "El link del concurso fue copiado correctamente",
  contestEditCopyContestLink: "Copiar link del concurso",
  contestEditGoToContest: "Ver Concurso",
  contestEditRegisteredAdminDelete: "Eliminar",
  contestEditRegisteredAdminRole: "Rol",
  contestEditRegisteredAdminUsername: "Coder",
  contestEditRegisteredGroupAdminName: "Grupo",
  contestEditTagDelete: "Eliminar",
  contestEditTagName: "Nombre de la etiqueta",
  contestEditTeamsGroupReplace: "Reemplazar grupo de equipos",
  contestEditTeamsGroupReplaced: "Grupo de equipos reemplazado correctamente",
  contestEditUnarchiveContest: "Desarchivar concurso",
  contestEditUnarchiveHelpText: "Este concurso ya se encuentra archivado. Si quieres regresarlo al listado de concursos no archivados, da clic en el bot\u00f3n.",
  contestEditUnarchivedSuccess: "Concurso desarchivado exitosamente.",
  contestEditWithTitle: "Editar concurso %(title)",
  contestEndTime: "Termina: %(endDate)",
  contestEnrollStatus: "Inscrito",
  contestFilterBy: "Filtrar por",
  contestFilterByAll: "Todos",
  contestFilterByRecommended: "Solo recomendados",
  contestFilterBySignedUp: "Soy participante",
  contestForTeamsCanNotChangeToContest: "Un concurso para equipos no se puede cambiar a concurso normal",
  contestGroupAdded: "Grupo agregado correctamente",
  contestGroupRemoved: "Grupo eliminado correctamente",
  contestInformationNotRequired: "La informaci\u00f3n de la cuenta para este concurso no fue requerida.",
  contestIntroDifferentStarts: "Una vez iniciado el concurso, su duraci\u00f3n ser\u00e1 de %(window_length).",
  contestIntroGoToHomePage: "Ir a la p\u00e1gina de inicio",
  contestIntroLogout: "Cerrar sesi\u00f3n",
  contestIntroLogoutToJoinWithRegisteredUser: "Es probable que hayas recibido la invitaci\u00f3n a este concurso con una cuenta distinta a la que tienes iniciada la sesi\u00f3n. \u00bfTe gustar\u00eda cerrar sesi\u00f3n y despu\u00e9s iniciar sesi\u00f3n con las credenciales correctas?",
  contestIntroPenaltyDesc: "Se penalizar\u00e1 con un tiempo de %(window_length) cada env\u00edo incorrecto.",
  contestIntroScoreboardTimePercent: "El scoreboard en vivo se mostrar\u00e1 al inicio y hasta %(window_length) despu\u00e9s.",
  contestIntroScoreboardTimePercentOneHundred: "El scoreboard en vivo se mostrar\u00e1 durante todo el concurso.",
  contestIntroScoreboardTimePercentZero: "El scoreboard no se mostrar\u00e1 durante el concurso.",
  contestIntroSubmissionsSeparationDesc: "Por cada env\u00edo incorrecto se deber\u00e1 esperar %(window_length) para hacer un nuevo env\u00edo.",
  contestLengthTooLong: "La duraci\u00f3n del concurso no puede ser mayor a 31 d\u00edas.",
  contestListArchivedContests: "Concursos archivados",
  contestListCurrent: "Actuales",
  contestListEmpty: "No hay concursos con esas caracter\u00edsticas",
  contestListFuture: "Pr\u00f3ximos",
  contestListPast: "Pasados",
  contestListShowAdminContests: "Tambi\u00e9n muestra concursos que administro",
  contestListSubmissions: "Env\u00edos",
  contestMustBeCreatedInPrivateMode: "El concurso debe ser creado en modo privado",
  contestNew: "Nuevo concurso",
  contestNewForm: "Estilo Preselectivo IOI",
  contestNewFormAdmissionMode: "Modo de acceso",
  contestNewFormAdmissionModeDescription: "Selecciona el modo de acceso del concurso. Existen tres modalidades distintas:<br /><ul><li>Privado: El concurso s\u00f3lo es visible para coders que hayan sido invitados expl\u00edcitamente.</li><li>Registro/abierto: Cualquier persona se puede registrar, s\u00f3lo tienen acceso las personas admitidas por admins.</li><li>P\u00fablico: Cualquier persona puede participar.</li></ul>",
  contestNewFormBasicInformationRequired: "La informaci\u00f3n b\u00e1sica es requerida",
  contestNewFormBasicInformationRequiredDesc: "Si est\u00e1 activado, todos los concursantes deben haber registrado su informaci\u00f3n b\u00e1sica para unirse al concurso (pa\u00eds, estado y escuela)",
  contestNewFormByContests: "En caso de empate, se desempatar\u00e1 por tiempo. El tiempo contar\u00e1 desde que se inicie el concurso hasta que cada problema sea resuelto.",
  contestNewFormByProblem: "En caso de empate, se desempatar\u00e1 por tiempo. El tiempo contar\u00e1 desde que se abra cada problema hasta que se resuelva.",
  contestNewFormByRuntime: "En caso de empate, se desempatar\u00e1 por tiempo de ejecuci\u00f3n del programa (milisegundos).",
  contestNewFormConacupStyle: "Estilo CONACUP",
  contestNewFormDecrementFactor: "El puntaje de cada problema estar\u00e1 dado por la f\u00f3rmula: (1 - (%(window_length) + %(window_length) * TT^2 / (10 * PT^2 + TT^2), donde PT es el penalty en minutos del env\u00edo y TT el tiempo total del concurso, en minutos.",
  contestNewFormDescription: "Descripci\u00f3n del concurso",
  contestNewFormDifferentStarts: "Inicios Diferentes",
  contestNewFormDifferentStartsDesc: "Si est\u00e1 activo, indica el tiempo en minutos que tiene el coder para concursar y enviar soluciones a partir de que entra al concurso en plataforma. El valor debe ser menor a la diferencia en minutos de la duraci\u00f3n del concurso. Si est\u00e1 desactivado, solo se puede participar  entre la hora de inicio y la hora de fin del concurso.",
  contestNewFormEndDate: "Fecha de Fin",
  contestNewFormEndDateDesc: "La hora (en hora local) en la que termina el concurso.",
  contestNewFormForTeams: "Concurso para equipos",
  contestNewFormForTeamsDesc: "Si est\u00e1 activado, s\u00f3lo pueden acceder equipos en lugar de identidades. Los equipos deben agregarse a un grupo de equipos. Esta opci\u00f3n s\u00f3lo est\u00e1 disponible para nuevos concursos.",
  contestNewFormICPCStyle: "Estilo ICPC",
  contestNewFormImmediateFeedbackDesc: "Despu\u00e9s de evaluar cada env\u00edo, se mostrar\u00e1 el veredicto.",
  contestNewFormImmediateSummaryFeedbackDesc: "Despu\u00e9s de evaluar cada env\u00edo, se mostrar\u00e1 el resumen de puntajes y veredictos para cada grupo de casos.",
  contestNewFormLanguageRemoveBlockedWarning: "No se puede quitar \"%(language)\" de los lenguajes porque hay por lo menos un problema que lo requiere",
  contestNewFormLanguages: "Establecer lenguajes para el concurso actual",
  contestNewFormNoPenalty: "Coders con el mismo puntaje quedar\u00e1n en empate, sin importar el tiempo que le haya tomado a cada coder.",
  contestNewFormNumberOfContestants: "N\u00famero de concursantes",
  contestNewFormNumberOfContestantsDesc: "N\u00famero de concursantes para cada equipo",
  contestNewFormOmiStyle: "Estilo OMI - IOI",
  contestNewFormPenaltyDesc: "Entero indicando el n\u00famero de minutos con que se penaliza por enviar una respuesta incorrecta.",
  contestNewFormPenaltyType: "Tipo de penalizaci\u00f3n",
  contestNewFormPenaltyTypeDesc: "Indica c\u00f3mo se calcula la penalizaci\u00f3n por env\u00edo: tiempo desde que inicia el concurso, tiempo desde que se abre el problema, o tiempo de ejecuci\u00f3n del programa.",
  contestNewFormPointDecrementFactor: "Factor de decremento de puntos",
  contestNewFormPointDecrementFactorDesc: "Un n\u00famero entre 0 y 1 inclusive. Si este n\u00famero es distinto de cero, el puntaje que se obtiene al resolver correctamente un problema decae conforme pasa el tiempo. El valor del puntaje estar\u00e1 dado por (1 - points_decay_factor) + points_decay_factor * TT^2 / (10 * PT^2 + TT^2), donde PT es el penalty en minutos del env\u00edo y TT el tiempo total del concurso, en minutos.",
  contestNewFormRecommended: "Concurso recomendado",
  contestNewFormRecommendedTextAdmin: "Habilita esta opci\u00f3n si deseas que tu concurso aparezca en la lista de Concursos Recomendados.",
  contestNewFormRecommendedTextNonAdmin: "Para mostrar tu concurso en la lista de Concursos Recomendados, contacta a soporte@omegaup.com.",
  contestNewFormScheduleContest: "Agendar concurso",
  contestNewFormScheduleVirtualContest: "Agendar concurso virtual",
  contestNewFormScoreMode: "Modo de puntaje",
  contestNewFormScoreModeAllOrNothing: "Todo o nada",
  contestNewFormScoreModeDesc: "Elige \"Todo o nada\" si quieres que los concursantes tengan que resolver todos los casos de los problemas para obtener puntos. Elige \"Parcial\" si quieres que los concursantes obtengan los puntos correspondientes al env\u00edo que resolvi\u00f3 m\u00e1s casos de prueba. Elige \"M\u00e1ximo por grupo\" si quieres que los concursantes obtengan los puntos correspondientes a todos los casos que llegaron a resolver con alguno de sus env\u00edos.",
  contestNewFormScoreModeMaxPerGroup: "M\u00e1ximo por grupo",
  contestNewFormScoreModePartial: "Parcial",
  contestNewFormScoreboardAtContestEnd: "El scoreboard se podr\u00e1 visualizar al final del concurso.",
  contestNewFormScoreboardAtEnd: "Scoreboard al finalizar el concurso",
  contestNewFormScoreboardAtEndDesc: "Mostrar autom\u00e1ticamente el scoreboard completo al finalizar el concurso.",
  contestNewFormScoreboardTimePercent: "\u00bfCu\u00e1nto tiempo se mostrar\u00e1 el Scoreboard? (%)",
  contestNewFormScoreboardTimePercentDesc: "Entero del 0 al 100, indicando el porcentaje de tiempo que el scoreboard ser\u00e1 visible.",
  contestNewFormShortTitleAlias: "Titulo corto (alias)",
  contestNewFormShortTitleAliasDesc: "El t\u00edtulo corto se usa para construir la URL del concurso (ejemplos: CodingCup2023, OFMI2024, CopaCentroAmericana2024, etc.). No puede contener espacios",
  contestNewFormStartDate: "Fecha de Inicio",
  contestNewFormStartDateDesc: "La fecha (en hora local) en la que inicia el concurso.",
  contestNewFormSubmissionsSeparation: "Separaci\u00f3n de env\u00edos",
  contestNewFormSubmissionsSeparationDesc: "Tiempo m\u00ednimo en minutos que debe de esperar un concursante despu\u00e9s de realizar un env\u00edo para hacer otro (m\u00ednimo 1 minuto).",
  contestNewFormTitlePlaceholderConacupStyle: "**Estilo CONACUP aplicado. Pon tu t\u00edtulo aqu\u00ed**",
  contestNewFormTitlePlaceholderICPCStyle: "**Estilo ICPC aplicado. Pon tu t\u00edtulo aqu\u00ed**",
  contestNewFormTitlePlaceholderIoiStyle: "**Estilo Preselectivo aplicado. Pon tu t\u00edtulo aqu\u00ed**",
  contestNewFormTitlePlaceholderOmiStyle: "**Estilo OMI aplicado. Tu t\u00edtulo aqu\u00ed**",
  contestNewFormUpdateContest: "Actualizar concurso",
  contestNewFormUserInformationRequired: "Solicitar acceso a informaci\u00f3n de participantes",
  contestNewFormUserInformationRequiredDesc: "Elige \"Opcional\" para permitir a cada coder decidir si comparte su informaci\u00f3n personal y participar de manera independiente. Si no, elige \"Requerido\", pero considera que algunas personas podr\u00edan optar por no participar.",
  contestNewInvalidStartTime: "La fecha de inicio debe ser antes que la fecha de fin",
  contestNotFound: "Concurso no encontrado",
  contestNotRegistered: "No est\u00e1s registrado para ese concurso",
  contestNotStarted: "Concurso no ha iniciado",
  contestOrderBy: "Ordenar por",
  contestOrderByContestants: "Concursantes",
  contestOrderByDuration: "Duraci\u00f3n",
  contestOrderByEnds: "Finaliza",
  contestOrderByOrganizer: "Organiza",
  contestOrderBySignedUp: "Inscrito",
  contestOrderByTitle: "Nombre",
  contestParticipant: "Coder",
  contestPracticeMode: "Pr\u00e1ctica",
  contestPrintableVersion: "Versi\u00f3n imprimible",
  contestPublicForTeamsNotSupported: "Los concursos p\u00fablicos para equipos no son soportados a\u00fan.",
  contestPublicRequiresProblem: "Los concursos p\u00fablicos necesitan tener un problema. Agr\u00e9gale un problema y m\u00e1rcalo como p\u00fablico en Editar Concurso.",
  contestRegistrationPreAcceptedDescription: "Esta cuenta ha sido invitada expl\u00edcitamente al concurso",
  contestReport: "Reporte de Concurso: %(contest_alias)",
  contestReportProblemWithAlias: "Problema: %(alias)",
  contestReportProblemWithPoints: "Puntos: %(points)",
  contestReportTotalPoints: "Total: %(total_points)",
  contestReportUsername: "Nombre de la cuenta: %(username)",
  contestScoreboardAdminLink: "Admin scoreboard link",
  contestScoreboardDownloadCsvFile: "Descargar scoreboard (.csv)",
  contestScoreboardLink: "Scoreboard link",
  contestScoreboardMergeChoseContests: "Elige los concursos",
  contestStartTime: "Inicia: %(startDate)",
  contestStartedTime: "Empez\u00f3: %(startedDate)",
  contestUpdateAlreadyHasRuns: "La duraci\u00f3n del concurso no se puede cambiar si ya tiene soluciones revisadas.",
  contestVirtualMode: "Virtual",
  contestWillBeginIn: "Este concurso iniciar\u00e1 en %(time)",
  contestsCreate: "Crear Concurso",
  contestsJoinScoreboards: "Unir Scoreboards",
  countryNotSet: "Pa\u00eds no establecido",
  courseActionScoreboard: "Scoreboard",
  courseAddContent: "A\u00f1adir contenido",
  courseAddLecturesAdd: "Agregar lecturas",
  courseAddLecturesAddAssignmentDesc: "Agrega las lecturas que quieras incluir, estas se guardar\u00e1n despu\u00e9s de que presiones el bot\u00f3n de A\u00f1adir contenido. Si a\u00fan no decides qu\u00e9 lecturas utilizar\u00e1s, puedes agregarlas m\u00e1s tarde.",
  courseAddLecturesAssignmentsDesc: "Escribe el nombre de la lectura que deseas agregar.",
  courseAddLecturesEditAssignmentDesc: "Agrega todas las lecturas que desees. Estas lecturas se almacenar\u00e1n presionando el bot\u00f3n Agregar lectura",
  courseAddProblemsAdd: "Agregar problemas",
  courseAddProblemsAddAssignmentDesc: "Agrega los problemas que quieras incluir, estos se guardar\u00e1n despu\u00e9s de que presiones el bot\u00f3n de A\u00f1adir contenido. Si a\u00fan no decides qu\u00e9 problemas utilizar\u00e1s, puedes agregarlos m\u00e1s tarde.",
  courseAddProblemsAssignmentsDesc: "Escribe el nombre del problema que deseas agregar.",
  courseAddProblemsEditAssignmentDesc: "Agrega todos los problemas que desees. Estos problemas se almacenar\u00e1n presionando el bot\u00f3n Agregar problema",
  courseArchiveConfirmText: "\u00bfEst\u00e1s seguro de que deseas realizar esta acci\u00f3n?",
  courseArchiveHelpText: "Al archivar un curso, \u00e9ste dejar\u00e1 de aparecer en todos los listados. La \u00fanica forma de acceder al mismo, es a trav\u00e9s de su URL o desde el listado de \"Cursos que administro\", en la pesta\u00f1a \"Cursos archivados\". Esta acci\u00f3n puede deshacerse.",
  courseArchivedSuccess: "Curso archivado exitosamente.",
  courseAssignmentAdded: "Se agreg\u00f3 exitosamente!",
  courseAssignmentConfirmDelete: "\u00bfRealmente desea eliminar %(assignment)?",
  courseAssignmentDelete: "Eliminar contenido",
  courseAssignmentDeleted: "Contenido eliminado existosamente!",
  courseAssignmentEdit: "Editar contenido",
  courseAssignmentEndDateBeforeCourseStartDate: "La fecha de fin es previa a la fecha de inicio del curso",
  courseAssignmentLectureAdded: "Lectura agregada exitosamente.",
  courseAssignmentLectureRemove: "Quitar lectura del trabajo",
  courseAssignmentLectureRemoved: "Lectura quitada exitosamente.",
  courseAssignmentLectureReorder: "Reordenar lecturas del trabajo",
  courseAssignmentLecturesEmpty: "No hay lecturas",
  courseAssignmentNewFormEndDateDesc: "Fecha (en tiempo local) en la que termina.",
  courseAssignmentNewFormSchedule: "A\u00f1adir contenido",
  courseAssignmentNewFormShortTitleAliasDesc: "El alias es usado para construir el URL del contenido (ejemplos: TAREA-SEMANA1, EXAMENFINAL)",
  courseAssignmentNewFormStartDateDesc: "Fecha (en tiempo local) en la que empieza.",
  courseAssignmentNewFormUpdate: "Actualizar contenido",
  courseAssignmentProblemAdded: "Problema agregado exitosamente.",
  courseAssignmentProblemConfirmRemove: "Realmente desea quitar %(problem)?",
  courseAssignmentProblemRemove: "Quitar problema del trabajo",
  courseAssignmentProblemRemoved: "Problema quitado exitosamente.",
  courseAssignmentProblemReorder: "Reordenar problemas del trabajo",
  courseAssignmentProblemRunsEmpty: "No hay env\u00edos",
  courseAssignmentProblemsEmpty: "No hay problemas",
  courseAssignmentReorder: "Reordenar contenido del curso",
  courseAssignmentStartDateBeforeCourseStartDate: "La fecha de inicio es previa a la fecha de inicio del curso",
  courseAssignmentTitle: "%(courseName) - %(assignmentName)",
  courseAssignmentUpdated: "Se actualiz\u00f3 exitosamente",
  courseBasicInformationNeeded: "- Para unirte al curso debes completar tu informaci\u00f3n b\u00e1sica. [Ir a mi perfil](/profile/#edit-basic-information).",
  courseCardCourseResume: "Continuar",
  courseCardImpartedBy: "Impartido por: **%(school_name)**",
  courseCardMustLogIn: "Debes iniciar sesi\u00f3n para ver estos cursos.",
  courseCardProgress: "Progreso:",
  courseCardPublicLevelAdvanced: "\u2605\u2605\u2605 Avanzado",
  courseCardPublicLevelIntermediate: "\u2605\u2605 Intermedio",
  courseCardPublicLevelIntroductory: "\u2605 Introductorio",
  courseCardsListSearch: "\ud83d\udd0d Nombre del curso",
  courseCloneCreatedBy: "Creado por",
  courseCloneGenerateLinkButton: "Generar liga",
  courseCloneGenerateLinkDescription: "Cualquier persona con quien compartas esta liga podr\u00e1 usarla para clonar el curso por un periodo de 7 d\u00edas",
  courseCloneGenerateLinkSuccess: "La liga se gener\u00f3 correctamente",
  courseCloneGenerateLinkTitle: "Generar liga para clonar",
  courseContentEmpty: "No hay contenido",
  courseContentNewFormTypeDesc: "El tipo de contenido es usado para distinguir una tarea de una lecci\u00f3n o examen visualmente en los cursos.",
  courseCreate: "Crear Curso",
  courseDetailsOverallCompletedPoints: "%(completed_points) de %(total_points) puntos",
  courseDetailsProgress: "Progreso del curso",
  courseDetailsSettings: "Ajustes",
  courseDetailsTabContent: "Contenido",
  courseDetailsTabInformation: "Informaci\u00f3n general",
  courseDoesNotAdmitRegistration: "El curso no admite registro de estudiantes",
  courseDoesNotHaveUnlimitedDuration: "No se puede establecer duraci\u00f3n ilimitada al contenido de un curso que no es de duraci\u00f3n ilimitada.",
  courseEdit: "Editar curso",
  courseEditAddAdminsTooltip: "Agrega admins utilizando su nombre de cuenta de omegaUp",
  courseEditAddGroupAdminsTooltip: "Agrega grupos de administradores. Aseg\u00farate de que el grupo existe.",
  courseEditAddGroupTeachingAssistantTooltip: "Agrega grupos de asistentes de ense\u00f1anza. Aseg\u00farate de que el grupo existe.",
  courseEditAddLectures: "Agregar lectura",
  courseEditAddProblems: "Agregar problema",
  courseEditAddStudentsAdd: "A\u00f1adir",
  courseEditAddStudentsDescription: "Administra a los estudiantes que van a participar en el curso",
  courseEditAddStudentsStudent: "Estudiante",
  courseEditAddTeachingAssistants: "Agregar asistente de ense\u00f1anza",
  courseEditAddTeachingAssistantsTooltip: "Agrega asistentes de ense\u00f1anza utilizando su nombre de cuenta de omegaUp",
  courseEditAdmins: "Admins",
  courseEditAdminsEmpty: "No hay administradores",
  courseEditAdmissionModeDescription: "Manual: Solo pueden inscribirse estudiantes que sean expl\u00edcitamente invitados.\nCompartir URL: Cualquiera con el link puede solicitar inscribirse. Adicionalmente, puedes agregar de forma manual el nombre de la cuenta de cada estudiante.",
  courseEditAdmissionModeSelect: "Seleccionar el modo de acceso del curso",
  courseEditArchive: "Archivar",
  courseEditClone: "Clonar",
  courseEditCourseClonedSuccessfully: "Tu curso ha sido clonado exitosamente. <a href=\"/course/%(course_alias)/edit/\">Editar curso</a>",
  courseEditCourseEdited: "Tu curso ha sido editado.",
  courseEditCourseEditedAndGoToCourse: "Tu curso ha sido editado. <a href=\"/course/%(alias)\">Ir al curso</a>",
  courseEditGoToCourse: "Ir al curso",
  courseEditGroupAdminsEmpty: "No hay grupos de admins",
  courseEditGroupTeachingAssistant: "Grupo de asistentes de ense\u00f1anza",
  courseEditGroupTeachingAssistantAdded: "Grupo de asistentes de ense\u00f1anza agregado correctamente",
  courseEditGroupTeachingAssistantRemoved: "Grupo de asistentes de ense\u00f1anza eliminado correctamente",
  courseEditGroupTeachingAssistantsEmpty: "No hay grupos de asistentes de ense\u00f1anza",
  courseEditRequestSetRecommendedCourse: "Si te interesa que tu curso aparezca en la lista de cursos p\u00fablicos, por favor contacta a [hello@omegaup.com](mailto:hello@omegaup.com) indicando el alias del curso para someterlo a revisi\u00f3n.",
  courseEditShowInPublicCoursesList: "Mostrar en la lista de cursos p\u00fablicos",
  courseEditStudents: "Estudiantes",
  courseEditTeachingAssistantAddedSuccessfully: "Asistente de ense\u00f1anza agregado correctamente",
  courseEditTeachingAssistantRemovedSuccessfully: "Asistente de ense\u00f1anza eliminado correctamente",
  courseEditTeachingAssistants: "Asistente de ense\u00f1anza",
  courseEditTeachingAssistantsEmpty: "No hay asistentes de ense\u00f1anza",
  courseExamEmpty: "No hay ex\u00e1menes",
  courseExtraPointsProblem: "V\u00e1lido para puntos extra",
  courseExtraPointsProblemDesc: "Los puntos de este problema solo se cuentan en caso de que no se llegue al puntaje m\u00e1ximo del curso.",
  courseExtraPointsProblemLabel: "Problema para puntos extra",
  courseGroupNotFound: "No se encontr\u00f3 el grupo del curso",
  courseHomepageStudentsSectionContent: "**Estudiantes**\n\n- Obtienen retroalimentaci\u00f3n autom\u00e1tica de sus soluciones.\n- Aprenden habilidades que les servir\u00e1n en su vida profesional.\n- Acceden a cursos en l\u00ednea 24/7.\n",
  courseHomepageTeachersSectionContent: "**Docentes**\n\n- Acceden y usar m\u00e1s de 2000 problemas de calidad para utilizar como tareas y ex\u00e1menes.\n- Observan el avance de sus estudiantes.\n- Identifican los temas que se est\u00e1n complicando a sus estudiantes.\n",
  courseHomepageTitle: "Descubriendo y preparando el talento de Latinoam\u00e9rica",
  courseIntroImpartedBy: "Organizado por",
  courseIntroLevel: "Nivel: %(level)",
  courseIntroWhatYouWillLearn: "Lo que aprender\u00e1s en este curso",
  courseInvalidStartTime: "La fecha de inicio debe ser antes que la fecha de fin",
  courseLevelAdvanced: "Avanzado",
  courseLevelAdvancedLevel: "Nivel avanzado",
  courseLevelAllLevels: "Todos los niveles",
  courseLevelIntermediate: "Intermedio",
  courseLevelIntermediateLevel: "Nivel intermedio",
  courseLevelIntroductory: "Introductorio",
  courseLevelIntroductoryLevel: "Nivel introductorio",
  courseList: "Lista de cursos",
  courseListAdminCourses: "Cursos que administro",
  courseListArchivedCourses: "Cursos archivados",
  courseListCurrentCourses: "Cursos actuales",
  courseListPastCourses: "Cursos pasados",
  courseListSubmissionsByGroup: "Env\u00edos realizados por estudiantes de este curso",
  courseListTeachingAssistantCourses: "Cursos a los que ayudo",
  courseNew: "Nuevo curso",
  courseNewFormBasicInformationRequired: "La informaci\u00f3n b\u00e1sica es requerida",
  courseNewFormBasicInformationRequiredDesc: "Si est\u00e1 activado, todos los concursantes deben haber registrado su informaci\u00f3n b\u00e1sica para unirse al curso (pa\u00eds, estado y escuela)",
  courseNewFormDescription: "Descripci\u00f3n",
  courseNewFormEndDate: "Fecha de fin",
  courseNewFormEndDateDesc: "La hora (en hora local) en la que termina el curso.",
  courseNewFormLanguages: "Establecer lenguajes para el curso actual",
  courseNewFormLevel: "Nivel",
  courseNewFormLevelDesc: "El nivel de dificultad del curso.",
  courseNewFormObjective: "Objetivo",
  courseNewFormObjectiveDesc: "Describe lo que tus estudiantes aprender\u00e1n en este curso.",
  courseNewFormScheduleCourse: "Agendar curso",
  courseNewFormShortTitleAlias: "T\u00edtulo corto (alias)",
  courseNewFormShortTitleAliasDesc: "El t\u00edtulo corto se usa para construir la URL del curso (ejemplos: IPNVERANO2016, ITVERINTRO2016)",
  courseNewFormShowScoreboard: "Mostrar scoreboard",
  courseNewFormShowScoreboardDesc: "Mostrar u ocultar los resultados generales a los alumnos del curso.",
  courseNewFormStartDate: "Fecha de inicio",
  courseNewFormStartDateDesc: "La hora (en hora local) en la que inicia el curso.",
  courseNewFormUnlimitedDuration: "Duraci\u00f3n ilimitada",
  courseNewFormUnlimitedDurationDesc: "Si est\u00e1 activado, la fecha de fin ser\u00e1 nula y el curso tendr\u00e1 duraci\u00f3n ilimitada.",
  courseNewFormUpdateCourse: "Actualizar curso",
  courseNewFormUserInformationRequired: "Solicitar informaci\u00f3n de participantes",
  courseNewFormUserInformationRequiredDesc: "Habilita esta opci\u00f3n para solicitar acceso a la informaci\u00f3n de los participantes que pertenecen al curso con el fin de ser contactados posteriormente. Ten en cuenta que el participante podr\u00e1 elegir si desea dar acceso a su informaci\u00f3n o no.",
  courseNotFound: "Curso no encontrado",
  coursePrivacyConsent: "Consentimiento de privacidad de curso",
  courseProgressGlobalScore: "Puntaje global",
  courseRegistrationPreAcceptedDescription: "Esta cuenta ha sido invitada expl\u00edcitamente al curso",
  courseRequestFeedback: "\u00bfTienes dudas? solicita una retroalimentacion sobre tu c\u00f3digo!",
  courseStatisticsAverageRuns: "N\u00famero promedio de env\u00edos",
  courseStatisticsAverageScore: "Promedio de puntaje",
  courseStatisticsMaximumScore: "Puntaje m\u00e1ximo",
  courseStatisticsMinimumScore: "Puntaje m\u00ednimo",
  courseStatisticsScoreVariance: "Varianza de puntaje",
  courseStatisticsStudentsAbove: "Estudiantes con puntaje mayor a 60%",
  courseStatisticsStudentsCompleted: "Estudiantes con puntuaje igual a 100%",
  courseStatisticsStudentsScored: "Estudiantes con puntaje de 0%",
  courseStatisticsVariance: "Varianza",
  courseStatisticsVerdicts: "Distribuci\u00f3n de veredictos",
  courseStudentAdded: "Estudiante agregado al curso exitosamente.",
  courseStudentCountLabel: "Estudiantes: %(student_count)",
  courseStudentNotInCourse: "El estudiante no estaba en el curso.",
  courseStudentRemoved: "Estudiante quitado del curso exitosamente.",
  courseStudentSelectAssignment: "Seleccionar trabajo",
  courseStudentSelectStudent: "Seleccionar estudiante",
  courseStudentsEmpty: "No hay estudiantes",
  courseStudentsProgress: "Progreso de los estudiantes",
  courseStudentsProgressExportToSpreadsheet: "Exportar tabla como:",
  courseSubmissionNotFound: "El env\u00edo para alg\u00fan problema de este curso no ha sido encontrado.",
  courseSubmissionsList: "Lista de env\u00edos en un curso",
  courseTabEnrolled: "Cursos que estudio (%(course_count))",
  courseTabEnrolledUnlogged: "Cursos que estudio",
  courseTabFinished: "Cursos terminados (%(course_count))",
  courseTabFinishedUnlogged: "Cursos terminados",
  courseTabPublic: "Explorar cursos",
  courseTabsEmptyEnrolledCourses: "No est\u00e1s inscrito en ning\u00fan curso",
  courseTabsEmptyFinishedCourses: "No hay cursos finalizados",
  courseUnarchivedSuccess: "Curso desarchivado exitosamente.",
  courseUpdateAlreadyHasRuns: "La duraci\u00f3n no se puede cambiar si ya existen soluciones revisadas.",
  courseWithoutProblems: "Sin problemas",
  createContestInteractiveGuideContestTitle: "Elige el t\u00edtulo de tu concurso",
  createContestInteractiveGuideDescription: "A\u00f1ade una descripci\u00f3n a tu concurso",
  createContestInteractiveGuideSchedule: "Despu\u00e9s de completar toda la informaci\u00f3n, programa el concurso",
  createContestInteractiveGuideShortTitle: "Elige un t\u00edtulo corto para tu concurso",
  createContestInteractiveGuideStyle: "Elige entre estilos de concursos predefinidos",
  createContestInteractiveGuideTitle: "Crear un concurso",
  createContestInteractiveGuideWelcome: "Vamos a crear un concurso",
  createCourseInteractiveGuideAskInformation: "Selecciona si deseas solicitar informaci\u00f3n personal de cada estudiante.",
  createCourseInteractiveGuideBasicInformation: "Selecciona si es obligatorio que cada estudiante comparta su informaci\u00f3n personal.",
  createCourseInteractiveGuideDescription: "Ingresa una breve descripci\u00f3n del curso.",
  createCourseInteractiveGuideDuration: "\u00bfQuieres que tenga duraci\u00f3n ilimitada?",
  createCourseInteractiveGuideEndDate: "Elige la fecha de finalizaci\u00f3n del curso.",
  createCourseInteractiveGuideLanguage: "Selecciona los lenguajes de programaci\u00f3n permitidos en tu curso.",
  createCourseInteractiveGuideLevel: "Selecciona el nivel de dificultad del curso",
  createCourseInteractiveGuideName: "Elige el nombre del curso.",
  createCourseInteractiveGuideObjective: "\u00bfCu\u00e1l ser\u00e1 el objetivo del curso?",
  createCourseInteractiveGuideSchool: "Ingresa el nombre de tu escuela.",
  createCourseInteractiveGuideScoreboard: "\u00bfQuieres mostrar el marcador en el curso?",
  createCourseInteractiveGuideShortTitle: "Elige un alias para el curso.",
  createCourseInteractiveGuideStartDate: "Elige la fecha de inicio del curso.",
  createCourseInteractiveGuideSubmit: "Agenda el curso.",
  createCourseInteractiveGuideTitle: "Crear Curso",
  createCourseInteractiveGuideWelcome: "Te damos la bienvenida, vamos a crear un curso.",
  createIdentitiesInteractiveGuideCopy: "Puedes copiarlo pulsando este bot\u00f3n",
  createIdentitiesInteractiveGuideExample: "Aqu\u00ed tienes un ejemplo de c\u00f3mo debes subir las identidades en el archivo.",
  createIdentitiesInteractiveGuideFormat: "Recuerda subirlas en formato CSV",
  createIdentitiesInteractiveGuideInformation: "Recuerda leer la informaci\u00f3n importante.",
  createIdentitiesInteractiveGuideInformationConfirm: "Despu\u00e9s de verificar que todo est\u00e9 correcto, haz clic en el bot\u00f3n de 'Crear identidades'.",
  createIdentitiesInteractiveGuideInformationPassword: "Despu\u00e9s de agregar el archivo, revisa los registros que se crearon y almacena las contrase\u00f1as generadas en un lugar seguro, ya que no se volver\u00e1n a mostrar.",
  createIdentitiesInteractiveGuidePassword: "\u00bfDeseas generar contrase\u00f1as de f\u00e1cil lectura?",
  createIdentitiesInteractiveGuideTitle: "Crear identidades",
  createIdentitiesInteractiveGuideUpload: "Carga tus identidades. Recuerda que debe ser un archivo con formato CSV.",
  createIdentitiesInteractiveGuideWelcome: "\u00a1Hola, vamos a crear identidades!",
  createProblemInteractiveGuideFile: "Sube el archivo .zip con la informacion del problema",
  createProblemInteractiveGuideOrigin: "Elije la fuente del problema",
  createProblemInteractiveGuideProblemTitle: "Elije el titulo del problema",
  createProblemInteractiveGuideShortTitle: "Elije un titulo corto para el problema",
  createProblemInteractiveGuideTagsAndLevel: "Elije las etiquetas y selecciona el nivel de tu problema",
  createProblemInteractiveGuideTitle: "Crear un problema",
  createProblemInteractiveGuideType: "Elije el tipo de problema",
  createProblemInteractiveGuideValidator: "Selecciona el tipo de validador de salida",
  createProblemInteractiveGuideWelcome: "Bienvenido, vamos a crear un problema",
  createZipFileForProblem: "Crear un archivo ZIP para el problema",
  csrfException: "Intento de Cross-site Request Forgery",
  currentStatus: "Estado actual",
  datePickerFormat: "dd/mm/yyyy",
  dateTimePickerFormat: "dd/mm/yyyy hh:ii",
  deleteProblemLevel: "Eliminar el nivel del problema",
  demotionProblemEmailBannedBody: "<p>Estimado <strong>%(user_name)</strong>:</p><p>El acceso a tu problema <strong>%(problem_name)</strong> en omegaup.com ha sido restringido debido a que ha sido reportado como un problema inapropiado. El equipo de omegaUp revis\u00f3 este reporte y confirm\u00f3 que el problema no es apropiado debido a que <em>%(reason)<em>.</p><p>Para desbloquear el problema y que vuelva a mostrarse en la lista de problemas, por favor sigue los siguientes pasos:</p><p><ol><li>Revisa y edita tu problema, asegurate que describa un problema, no sea ofensivo ni spam.</li><li>Una vez que hayas resuelto la raz\u00f3n por la que tu problema fue bloqueado, manda un email a <a href=\"mailto:quality@omegaup.com\" target=\"_top\">quality@omegaup.com</a> para que sea revisado y reactivado.</li></ol></p><p>De no seguirse los pasos mencionados arriba, el problema no se volver\u00e1 a mostrar en la lista de problemas ni se podr\u00e1 utilizar en concursos. En caso de reincidir 3 veces, omegaUp se reserva el derecho de suspender tu cuenta.</p><p>omegaUp es una plataforma para ayudar a las personas a mejorar sus habilidades en ingenier\u00eda de software resolviendo problemas de c\u00f3digo y compitiendo en concursos de programaci\u00f3n. omegaUp da la bienvenida a todos los problemas que ayuden a cumplir esa meta.</p><p>Gracias,</p><p>Equipo omegaUp</p>",
  demotionProblemEmailBannedSubject: "El problema [%(problem_name)] ha sido reportado como inapropiado",
  demotionProblemEmailWarningBody: "<p>Estimado %(user_name):</p><p>El acceso a tu problema %(problem_name) en omegaup.com ha sido marcado con una advertencia debido a que ha sido reportado por otras cuentas. El equipo de omegaUp revis\u00f3 este reporte y confirm\u00f3 que el problema tiene aspectos mejorables debido a que %(reason).</p><p>Para retirar la notificaci\u00f3n de advertencia del problema y que vuelva a mostrarse de manera normal, por favor sigue los siguientes pasos:</p><p><ol><li>Revisa y edita tu problema.</li><li>Una vez que hayas resuelto la raz\u00f3n por la que tu problema fue marcado con una advertencia, manda un email a quality@omegaup.com para que sea revisado.</li></lo></p><p>De no seguirse los pasos mencionados arriba, el problema mostrar\u00e1 una advertencia a quienes intenten resolverlo y/o verlo.</p><p>omegaUp es una plataforma para ayudar a las personas a mejorar sus habilidades en ingenier\u00eda de software resolviendo problemas de c\u00f3digo y compitiendo en concursos de programaci\u00f3n. omegaUp da la bienvenida a todos los problemas que ayuden a cumplir esa meta.</p><p>Gracias,</p><p>Equipo omegaUp</p>",
  demotionProblemEmailWarningSubject: "El problema [%(problem_name)] ha sido marcado con una advertencia",
  demotionProblemMultipleAnswerNo: "No, solo este reporte",
  demotionProblemMultipleAnswerYes: "Si, marcar todos",
  demotionProblemMultipleQuestion: "\u00bfDeseas realizar esta acci\u00f3n para todos los reportes de este problema?",
  demotionProblemNotificationBanned: "El problema [%(problem_name)] ha sido reportado como inapropiado. Para m\u00e1s detalles revisa tu correo electr\u00f3nico.",
  demotionProblemNotificationWarning: "El problema [%(problem_name)] ha sido marcado con una advertencia. Para m\u00e1s detalles revisa tu correo electr\u00f3nico.",
  dependentsBlockedMessage: "Cuenta bloqueada. Para validar al dependiente, es necesario ponerse en contacto con nuestro equipo de soporte.",
  dependentsMessage: "Es necesario que apruebe la cuenta de su dependiente en un plazo de %(days) d\u00edas. De lo contrario, la cuenta ser\u00e1 eliminada.",
  dependentsOneDayUntilVerificationDeadline: "\u00a1Atenci\u00f3n! Solo queda 1 d\u00eda para que apruebe la cuenta de su dependiente. De lo contrario, la cuenta ser\u00e1 eliminada.",
  dependentsStatus: "Estatus",
  dependentsTitle: "Acceso parental",
  dependentsUser: "Usuario",
  dependentsVerified: "La cuenta del dependiente ha sido verificada correctamente",
  downloadZip: "Descargar zip",
  duplicateTagsNotAllowed: "No se permiten etiquetas duplicadas. Hay al menos una etiqueta duplicada en la lista: %(tags) <br> Corrija la informaci\u00f3n.",
  editFieldRequired: "Falta un valor requerido",
  emailNotVerified: "Tu direcci\u00f3n de correo a\u00fan no ha sido verificada. Busca el correo de verificaci\u00f3n en tu bandeja de entrada o de spam. Si sigues teniendo problemas, escribe a soporte@omegaup.com para obtener ayuda.",
  enterContest: "Entrar al concurso",
  ephemeralGraderAlert: "Necesitas una pantalla de mayor tama\u00f1o para poder usar el Ephemeral Grader. Intente poner el tel\u00e9fono en posici\u00f3n horizontal o usar otro dispositivo.",
  errorWhileSendingMail: "Hubo un problema al enviar el correo de verificaci\u00f3n. Por favor intenta m\u00e1s tarde o escribe a soporte@omegaup.com para obtener ayuda. Tu direcci\u00f3n de correo a\u00fan no ha sido verificada.",
  feedbackLeftBy: "%(date), por:",
  feedbackNotSentYet: "A\u00fan no se ha enviado la retroalimentaci\u00f3n para este env\u00edo.",
  feedbackSuccessfullyAdded: "La retroalimentaci\u00f3n se agreg\u00f3 correctamente.",
  feedbackSuccessfullyUpdated: "La retroalimentaci\u00f3n se actualiz\u00f3 correctamente.",
  feedbackTitle: "Retroalimentaci\u00f3n sobre el env\u00edo",
  firstSumbissionWithIdentity: "Ten en cuenta que est\u00e1s intentando enviar una soluci\u00f3n con una cuenta de identidad",
  fontSize: "Tama\u00f1o de fuente",
  forSelectedItems: "Para los items seleccionados",
  forbiddenInVirtualContest: "Prohibido en concurso virtual",
  frontPageDevelopers: "Desarrolladores",
  frontPageFooter: "incrementando el n\u00famero de ingenieros de software talentosos en Am\u00e9rica Latina.",
  frontPageFooterAboutUs: "Acerca de omegaUp",
  frontPageFooterCodeConduct: "C\u00f3digo de Conducta",
  frontPageFooterContact: "Contacto",
  frontPageFooterCopyright: "Copyright \u00a9 %(currentYear) omegaUp, Inc. Todos los derechos reservados.",
  frontPageFooterHelpUs: "Ay\u00fadanos",
  frontPageFooterOrganization: "Organizaci\u00f3n",
  frontPageFooterPrivacyPolicy: "Pol\u00edticas de privacidad",
  frontPageFooterSite: "Sitio",
  frontPageFooterSponsors: "Patrocinador",
  frontPageFooterTeam: "Equipo",
  frontPageNextContests: "Pr\u00f3ximos concursos",
  generalError: "Oops. Ocurri\u00f3 un error interno. Por favor int\u00e9ntalo nuevamente.",
  groupAdminAdded: "Grupo de administradores agregado correctamente",
  groupAdminRemoved: "Grupo de administradores eliminado correctamente",
  groupCreateIdentities: "Crear identidades",
  groupEditEdit: "Editar",
  groupEditGroupUpdated: "El grupo se actualiz\u00f3 correctamente.",
  groupEditMemberAdded: "Miembro agregado correctamente.",
  groupEditMemberPasswordUpdated: "Contrase\u00f1a de la identidad actualizada correctamente.",
  groupEditMemberRemoved: "Miembro eliminado correctamente.",
  groupEditMemberUpdated: "Miembro actualizado correctamente.",
  groupEditMembers: "Miembros",
  groupEditMembersAddMembers: "Agregar miembros",
  groupEditMembersChangePassword: "Haz clic para cambiar la contrase\u00f1a",
  groupEditMembersCoder: "Coder",
  groupEditMembersEdit: "Haz clic para editar la informaci\u00f3n del miembro",
  groupEditMembersRemove: "Haz clic para eliminar el miembro del grupo",
  groupEditMembersTitle: "Agregar miembros para el equipo: %(username)",
  groupEditScoreboards: "Scoreboards",
  groupEditScoreboardsAdd: "Crear scoreboard",
  groupEditScoreboardsAddContest: "Agregar concurso",
  groupEditScoreboardsAdded: "Scoreboard agregado correctamente.",
  groupEditScoreboardsContestsAdded: "Concurso agregado correctamente.",
  groupEditScoreboardsContestsRemoved: "Concurso eliminado correctamente.",
  groupEditScoreboardsEdit: "Editar scoreboard %(scoreboard)",
  groupEditTitle: "Editar grupo",
  groupEditTitleWithName: "Editar grupo %(name)",
  groupIdentitiesNotRequiredPrivileges: "No cuentas con los permisos necesarios para crear identidades. Para obtenerlos envia un correo electronico a *[soporte@omegaup.com](mailto:soporte@omegaup.com?subject=Solicitud%20de%20Acceso%20a%20Creacion%20de%20Identidades)* con el titulo \"Solicitud de Acceso a Creacion de Identidades\" los siguientes detalles:\n\n- Nombre del concurso\n- Institucion organizadora\n- Nombre del contacto de la institucion organizadora\n- Nombre de usuario en omegaUp del contacto\n- N\u00famero aproximado de concursantes que tendr\u00e1n\n- Fecha del concurso\n\nSi tu concurso va a comenzar en menos de 48 horas incluye el texto **\"URGENTE\"** en el titulo de tu correo.",
  groupMemberUsernameInUse: "Existe al menos un nombre de cuenta duplicado en las identidades del grupo: <br> %(usernames) <br> Por favor corrige la informaci\u00f3n.",
  groupModalBack: "Atr\u00e1s",
  groupModalSave: "Guardar",
  groupNewFormCreateGroup: "Crear grupo",
  groupNewFormDescription: "Descripci\u00f3n del grupo",
  groupNewFormOnlyAC: "Contar s\u00f3lo ACs",
  groupNewFormUpdateGroup: "Guardar cambios",
  groupNewFormWeight: "Peso del puntaje",
  groupNotFound: "Grupo no encontrado",
  groupScoreboardDetailsCoder: "Coder",
  groupsCanNotBeAddedInContestForTeams: "No se pueden agregar grupos en concursos para equipos",
  groupsCreateNew: "Crear grupo",
  groupsCsvHelp: "<p>Agrega r\u00e1pidamente m\u00faltiples identidades a este grupo. Las identidades no son cuentas normales y no necesitan tener un correo electr\u00f3nico o validar su cuenta.</p>\n<p>Las identidades deben estar en un archivo <code>.csv</code> con el siguiente formato:\n<samp><pre>username,name,country_id,state_id,gender,school_name\nusername-1,Developer Diana,MX,AGU,female,Best School\nusername-2,Danny Dev,MX,AGU,male,Best School</pre></samp></p>",
  groupsIdentitiesSuccessfullyCreated: "Las identidades han sido creadas y ligadas al grupo.",
  groupsIdentityWarning: "Guarda las contrase\u00f1as en un lugar seguro, porque una vez que crees las identidades, no habr\u00e1 forma de recuperar las contrase\u00f1as.",
  groupsInvalidCsv: "Favor de cargar un archivo CSV v\u00e1lido.",
  groupsUploadCsvFile: "Carga el archivo CSV",
  homepageCompeteSectionDescription: "Participa en concursos de programaci\u00f3n y pon a prueba tus conocimientos",
  homepageCompeteSectionTitle: "Compite",
  homepageCreateSectionDescription: "Organiza tu concurso con problemas que est\u00e1n disponibles en la plataforma o crea tus propios problemas",
  homepageCreateSectionTitle: "Crea",
  homepageSponsorsSectionTitle: "Gracias a nuestro Patrocinador",
  homepageTeachSectionDescription: "Sigue el progreso de tus estudiantes a trav\u00e9s de tareas y ex\u00e1menes que se eval\u00faan autom\u00e1ticamente",
  homepageTeachSectionTitle: "Ense\u00f1a",
  homepageTrainSectionDescription: "Resuelve problemas y mejora tus habilidades",
  homepageTrainSectionTitle: "Entrena",
  identityAlreadyAssociated: "Ya cuentas con una identidad asociada con el mismo grupo.",
  identityAlreadyInUse: "La identidad ya est\u00e1 siendo utilizada por otra cuenta.",
  identityInGroup: "La identidad ya est\u00e1 asociada al grupo.",
  incompatibleArgs: "Los par\u00e1metros problemset_id y contest_alias no se pueden utilizar al mismo tiempo",
  interactiveGuideDoneButton: "Listo",
  interactiveGuideNextButton: "Siguiente",
  interactiveGuidePreviousButton: "Anterior",
  invalidLanguage: "Languaje inv\u00e1lido",
  invalidParameters: "Par\u00e1metros inv\u00e1lidos.",
  invalidResetToken: "Token inv\u00e1lido.",
  invalidScoreboardUrl: "Url de scoreboard inv\u00e1lido",
  invalidStatementType: "Redacci\u00f3n del problema inv\u00e1lida",
  invalidUser: "Nombre de cuenta no v\u00e1lido.",
  invalidVisibility: "El par\u00e1metro visibility puede ser alguno de los siguientes valores: deleted, private_banned, public_banned, private_warning, private, public_warning, public y promoted",
  joinCourseInteractiveGuideJoin: "Haz clic en el bot\u00f3n de iniciar para unirte a un curso.",
  joinCourseInteractiveGuideSearch: "Aqu\u00ed podr\u00e1s buscar cursos por nombre.",
  joinCourseInteractiveGuideTabs: "Aqu\u00ed podr\u00e1s navegar entre los cursos que estas cursando, los que has completado y explorar nuevos cursos.",
  joinCourseInteractiveGuideTitle: "Unirse a un curso",
  joinCourseInteractiveGuideWelcome: "\u00a1Hola! Aqu\u00ed podr\u00e1s encontrar tus cursos.",
  lastUpdate: "\u00daltima actualizaci\u00f3n",
  levelTagHelp: "Los niveles deben coincidir con la trayectoria escolar de un alumno y van de la mano con los cursos que suelen tomar.",
  libinteractiveDownload: "Descargar",
  libinteractiveFilename: "Archivo que debes enviar",
  libinteractiveIdlFilename: "Nombre de archivo del .idl",
  libinteractiveIdlFilenameHelp: "El nombre del archivo .idl (sin la extensi\u00f3n). Debe tener entre 1 y 32 caracteres alfanum\u00e9ricos.",
  libinteractiveLanguage: "Lenguaje",
  libinteractiveOs: "Sistema Operativo",
  libinteractiveTitle: "Plantillas para problema interactivo",
  liveStatistics: "Estad\u00edsticas en vivo",
  locale: "es",
  lockdown: "Operaci\u00f3n no permitida en modo lockdown",
  lockdownDetailsDisabled: "Ver el c\u00f3digo ha sido temporalmente desactivado.",
  lockdownMessageWarning: "Advertencia: en modo lockdown, tus env\u00edos ya no ser\u00e1n accesibles si te sales de la p\u00e1gina.",
  loginAccountName: "Nombre de la cuenta",
  loginDateOfBirth: "Fecha de nacimiento",
  loginDisabled: "Tu cuenta ha estado inactiva por mucho tiempo y por tu seguridad ha sido deshabilitada. Para ingresar de nuevo contacta a soporte@omegaup.com",
  loginEmail: "E-mail",
  loginEmailUsername: "E-mail o nombre de cuenta",
  loginFacebookEmptyEmailError: "Se necesita acceso a tu direcci\u00f3n de correo para utilizar omegaUp. Por favor permite el acceso a tu correo de Facebook para continuar.",
  loginFederated: "Cuenta en otros sitios",
  loginGoogleInvalidCSRFToken: "Token CSRF inv\u00e1lido",
  loginHeader: "Inicia sesi\u00f3n en omegaUp",
  loginLogIn: "Iniciar sesi\u00f3n",
  loginNative: "Cuenta omegaUp",
  loginParentEmail: "Correo electr\u00f3nico de figura parental",
  loginPassword: "Contrase\u00f1a",
  loginPasswordCreate: "Contrase\u00f1a (Min. 8 caracteres)",
  loginPasswordTooShort: "La contrase\u00f1a es muy corta",
  loginRecover: "\u00bfOlvidaste tu contrase\u00f1a?",
  loginRepeatPassword: "Repetir contrase\u00f1a",
  loginRequired: "Necesitas iniciar sesi\u00f3n para realizar esa acci\u00f3n",
  loginSignUp: "Registrar",
  loginSignupHeader: "Crea una cuenta omegaUp, \u00a1es f\u00e1cil y r\u00e1pido!",
  loginThroughThirdParty: "Tu cuenta fue creada mediante un login externo (Google, Facebook, etc.). Por favor inicia sesi\u00f3n usando el mismo m\u00e9todo para poder establecer una contrase\u00f1a.",
  logoutConfirmationTitle: "Confirmar cierre de sesi\u00f3n",
  mailFromUserLikelyRemoved: "Este correo ya est\u00e1 en uso. Probablemente este fue usado pero la cuenta fue eliminada. Si deseas utilizar el correo escribe a soporte@omegaup.com para obtener ayuda",
  mailInUse: "El email seleccionado ya est\u00e1 ocupado. Intenta con otro email v\u00e1lido.",
  makePrivate: "Hacer privado",
  makePublic: "Hacer p\u00fablico",
  makeRegistration: "Hacer abierto con registro",
  matrixEditTitle: "Editor de matriz",
  matrixModalBack: "Atr\u00e1s",
  matrixModalColumns: "Columnas",
  matrixModalDistinct: "Distinto",
  matrixModalDistinctAll: "Todos",
  matrixModalDistinctColumn: "Columna",
  matrixModalDistinctHeader: "Seleccionar tipo distinto",
  matrixModalDistinctNone: "Ninguno",
  matrixModalDistinctRow: "Fila",
  matrixModalGenerate: "Generar",
  matrixModalGeneratedArray: "Matriz generada",
  matrixModalMaximum: "M\u00e1ximo",
  matrixModalMinimum: "M\u00ednimo",
  matrixModalRows: "Filas",
  matrixModalSave: "Guardar",
  messageMakeYourContestsPublic: "Tienes concursos privados que ya han terminado. Por favor considera hacerlos p\u00fablicos y as\u00ed contribuir a la comunidad.",
  messageMakeYourProblemsPublic: "Tienes problemas privados que ya han sido utilizados. Por favor considera hacerlos p\u00fablicos y as\u00ed contribuir a la comunidad.",
  modalConsentCookiesAccept: "Aceptar todas las cookies",
  modalConsentCookiesDecline: "Aceptar solo las cookies esenciales",
  modalConsentCookiesDescription: "Usamos cookies para asegurar que tengas la mejor experiencia en nuestro sitio.",
  mustLoginToFilterUsers: "Para filtrar a coders del ranking debes iniciar sesi\u00f3n.",
  mustLoginToJoinContest: "Debes iniciar sesi\u00f3n para poder participar en este concurso",
  mustRegisterToJoinContest: "Para participar en este concurso debes registrarte",
  mustRegisterToJoinCourse: "Para participar en este curso debes registrarte",
  mustUpdateBasicInfoToFilterUsers: "No puedes usar los filtros del ranking si la informaci\u00f3n de tu perfil no est\u00e1 completa.",
  myproblemsListCreateProblem: "Crear Problema",
  myproblemsListCreateProblemWithExistingZipFile: "Tengo un archivo zip",
  myproblemsListCreateZipFileProblem: "Crear archivo zip",
  myproblemsListMyProblems: "Mis Problemas",
  navAlgorithmsBook: "Libro tutorial \"Problemas y Algoritmos\" por Luis Vargas",
  navAllCourses: "Todos los cursos",
  navAllProblems: "Todos los problemas",
  navAuthorRanking: "Ranking de contribuidores",
  navBlog: "Blog",
  navCoderOfTheMonth: "Coder del mes general",
  navCoderOfTheMonthFemale: "Coder del mes para ellas",
  navContests: "Concursos",
  navContestsEnrolled: "Concursos inscrito",
  navCourses: "Cursos",
  navCoursesEnrolled: "Cursos inscrito",
  navDependents: "Mis dependientes",
  navDiscord: "Servidor de Discord",
  navHelp: "Ayuda",
  navLogIn: "Inicia sesi\u00f3n / Registrarse",
  navMyContent: "Mi contenido",
  navMyContests: "Mis concursos",
  navMyCourses: "Mis cursos",
  navMyGroups: "Mis grupos",
  navMyProblems: "Mis problemas",
  navMyQualityNomination: "Mis reportes de problemas",
  navMyTeamsGroups: "Mis grupos de equipos",
  navProblems: "Problemas",
  navProfileProblems: "Problemas resueltos e intentados",
  navQualityNominationQueue: "Reportes",
  navRanking: "Ranking",
  navSchoolOfTheMonth: "Escuela del mes",
  navSchoolRanking: "Ranking de escuelas",
  navTutorials: "Tutoriales",
  navUserRanking: "Ranking de coders",
  navViewBadges: "Ver insignias",
  navViewContests: "Ver Concursos",
  navViewCourses: "Ver Cursos",
  navViewLatestSubmissions: "Ver \u00daltimos Env\u00edos",
  navViewProblems: "Explorar Problemas",
  navViewProblemsAll: "Lista de Problemas",
  navViewProfile: "Mi perfil",
  newPublicTagsNotAllowed: "No est\u00e1 permitido agregar nuevas etiquetas p\u00fablicas",
  noCoders: "No hay coders",
  nominationsRangeHeader: "Reportes de problemas (del %(lowCount) al %(highCount))",
  notProblemLevelTag: "La etiqueta enviada no es una etiqueta de nivel.",
  notificationContestClarificationRequest: "Ha sido solicitada una nueva clarificaci\u00f3n para el problema %(problemAlias) del concurso %(contestAlias), que administras.",
  notificationContestClarificationResponse: "Su pedido de clarificaci\u00f3n para el problema %(problemAlias) del concurso %(contestAlias), ha sido respondido.",
  notificationContestRegisterRequest: "%(username) ha pedido registrarse para el concurso %(contestTitle) que t\u00fa manejas.",
  notificationContestRegisterationAccepted: "La solicitud de registro para el concurso %(contestTitle) ha sido **aceptada**.",
  notificationContestRegisterationRejected: "La solicitud de registro para el concurso %(contestTitle) ha sido **rechazada**.",
  notificationCourseAddAdmin: "Has sido invitado a ser administrador del curso %(courseName).",
  notificationCourseAddTeachingAssistant: "Has sido invitado a ser un asistente de ense\u00f1anza del curso %(courseName).",
  notificationCourseAssignmentAdded: "Se ha agregado nuevo contenido al curso %(courseName).",
  notificationCourseAssignmentProblemAdded: "Se ha agregado un nuevo problema a una asignaci\u00f3n del curso %(courseName).",
  notificationCourseClarificationRequest: "Ha sido solicitada una nueva clarificaci\u00f3n para el problema %(problemAlias) del curso %(courseName), que administras.",
  notificationCourseClarificationResponse: "Su pedido de clarificaci\u00f3n para el problema %(problemAlias) del curso %(courseName), ha sido respondido.",
  notificationCourseRegistrationAccepted: "Tu solicitud de registro en el curso %(courseName) ha sido **aceptada**.",
  notificationCourseRegistrationManual: "Has sido invitado a unirte al curso %(courseName).",
  notificationCourseRegistrationRejected: "Tu solicitud de registro en el curso %(courseName) ha sido **rechazada**.",
  notificationCourseRegistrationRequest: "**%(username)** ha solicitado acceso al curso %(courseName).",
  notificationCourseRequestFeedback: "**%(username)** ha solicitado retroalimentacion en la asignacion ***%(assignmentName)*** del curso ***%(courseName)***",
  notificationCourseSubmissionFeedback: "Ha sido enviada la retroalimentaci\u00f3n sobre su env\u00edo para el problema ***%(problemAlias)*** en el curso ***%(courseName)***",
  notificationCourseSubmissionFeedbackThread: "**%(username)** ha respondido en una retroalimentaci\u00f3n sobre el env\u00edo para el problema ***%(problemAlias)*** en el curso ***%(courseName)***",
  notificationNewBadge: "Has recibido una nueva insignia: **%(badgeName)**.",
  notificationNewContestCertificate: "\u00a1Felicidades! Has recibido un diploma por tu reciente logro en el concurso \"%(contest_title)\". Haz clic para descargarlo.",
  notificationNotFound: "No se encontr\u00f3 la notificaci\u00f3n",
  notificationsMarkAllAsRead: "Marcar todo como le\u00eddo",
  notificationsNoNewNotifications: "No hay nuevas notificaciones.",
  officialSolutionsInfo: "\u00bfC\u00f3mo funcionan las soluciones de problemas?",
  omegaUpTitleMyDependents: "Mis dependientes",
  omegaupTitleAdminUsers: "Administraci\u00f3n de coders",
  omegaupTitleAuthorsRank: "Ranking de contribuidores",
  omegaupTitleBadges: "Insignias",
  omegaupTitleCertificate: "Diplomas",
  omegaupTitleCertificateValidation: "Verificar diploma",
  omegaupTitleCodersofthemonth: "Programadores del mes",
  omegaupTitleCodersofthemonthFemale: "Programadoras del mes",
  omegaupTitleCollections: "Colecciones",
  omegaupTitleCollectionsByAuthor: "Problemas por autor",
  omegaupTitleCollectionsByLevel: "Problemas por nivel",
  omegaupTitleCommonIndex: "Bienvenido",
  omegaupTitleContest: "Concurso",
  omegaupTitleContestAddAdmin: "Administradores",
  omegaupTitleContestEdit: "Editar concurso",
  omegaupTitleContestList: "Lista de concursos",
  omegaupTitleContestNew: "Nuevo concurso",
  omegaupTitleContestPractice: "Concurso (Modo pr\u00e1ctica)",
  omegaupTitleContestPrint: "Concurso (Modo impresi\u00f3n) - %(contestTitle)",
  omegaupTitleContestReport: "Reporte para el concurso: %(contestName)",
  omegaupTitleContestScoreboard: "Scoreboard del concurso",
  omegaupTitleContestStats: "Estad\u00edsticas de concurso",
  omegaupTitleCourseClarifications: "Clarificaciones del curso",
  omegaupTitleCourseDetails: "Detalles del curso",
  omegaupTitleCourseEdit: "Editar curso",
  omegaupTitleCourseIntro: "Entrar al curso",
  omegaupTitleCourseNew: "Nuevo curso",
  omegaupTitleCourseScoreboard: "Scoreboard del curso",
  omegaupTitleCourseStatistics: "Estad\u00edsticas del curso",
  omegaupTitleCourses: "Cursos",
  omegaupTitleDocs: "\u00cdndice de Documentaci\u00f3n",
  omegaupTitleGroupScoreboardDetails: "Detalles del scoreboard del grupo",
  omegaupTitleGroups: "Grupos",
  omegaupTitleGroupsEdit: "Editar grupo",
  omegaupTitleGroupsNew: "Nuevo grupo",
  omegaupTitleGroupsScoreboardEdit: "Editar scoreboard",
  omegaupTitleLatestSubmissions: "\u00daltimos env\u00edos",
  omegaupTitleLibInteractive: "libinteractive",
  omegaupTitleLogin: "Inicio de sesi\u00f3n",
  omegaupTitleLogout: "Cerrar sesi\u00f3n",
  omegaupTitleMyCertificates: "Mis diplomas",
  omegaupTitleMyContests: "Mis concursos",
  omegaupTitleMyProblemsList: "Mis problemas",
  omegaupTitleParentalVerificationToken: "Token de verificaci\u00f3n parental",
  omegaupTitlePrivacyPolicy: "Pol\u00edtica de privacidad",
  omegaupTitleProblem: "Problema",
  omegaupTitleProblemCreator: "Creador de Problemas",
  omegaupTitleProblemEdit: "Ajustes de problema",
  omegaupTitleProblemNew: "Problema nuevo",
  omegaupTitleProblemPrint: "Problema (modo impresi\u00f3n) - %(problemTitle)",
  omegaupTitleProblemStats: "Estad\u00edsticas de problema",
  omegaupTitleProblems: "Problemas",
  omegaupTitleProfile: "Perfil",
  omegaupTitleQualityNominationDetails: "Detalles del problema reportado",
  omegaupTitleQualityNominationList: "Lista de reporte de problemas",
  omegaupTitleQualityNominationMyList: "Mi lista de reporte de problemas",
  omegaupTitleRecoverPassword: "Recupera tu contrase\u00f1a",
  omegaupTitleSchoolOfTheMonth: "Escuelas del Mes",
  omegaupTitleSchoolProfile: "Perfil de Escuela",
  omegaupTitleSchoolsRank: "Ranking de escuelas",
  omegaupTitleScoreboardmerge: "Unir scoreboards",
  omegaupTitleStatementEditor: "Editor de redacciones",
  omegaupTitleStudentsProgress: "Progreso de los estudiantes",
  omegaupTitleSupportDashboard: "Tablero de soporte",
  omegaupTitleTeamsGroupEdit: "Editar grupo de equipos",
  omegaupTitleTeamsGroupNew: "Nuevo grupo de equipos",
  omegaupTitleTeamsGroups: "Grupos de equipos",
  omegaupTitleUpdatePrivileges: "Actualizar privilegios",
  omegaupTitleUsersEditEmail: "Editar correo electr\u00f3nico",
  omegaupTitleUsersRank: "Ranking de coders",
  onlyDemotionsSupported: "Solamente se pueden resolver demociones por ahora.",
  openInKarelJs: "Puedes utilizar karel.js para resolver este problema",
  originalContestHasNotEnded: "El concurso original a\u00fan no ha terminado",
  outputOnly: "S\u00f3lo salida",
  outputOnlyDownloadInput: "Descargar .zip con los casos de entrada",
  outputOnlyFiles: "S\u00f3lo archivos de salida",
  over13yearsOld: "Tengo m\u00e1s de 13 a\u00f1os.",
  parameterDateTooLarge: "La fecha excede el l\u00edmite superior de %(upper_bound!timestamp)",
  parameterDateTooSmall: "La fecha es menor al l\u00edmite inferior de %(lower_bound!timestamp)",
  parameterEmpty: "El campo no puede estar vac\u00edo",
  parameterInvalid: "Par\u00e1metro inv\u00e1lido",
  parameterInvalidAlias: "El campo debe constar de letras, n\u00fameros y _. Los espacios no son permitidos",
  parameterInvalidGroupAlias: "Par\u00e1metro inv\u00e1lido: group. El grupo no existe, crealo en https://omegaup.com/group/new/",
  parameterInvalidStateDoesNotBelongToCountry: "El estado seleccionado no pertenece al pa\u00eds basado en ISO 3166-2.",
  parameterInvalidStateNeedsToBelongToCountry: "Debes seleccionar el pa\u00eds para seleccionar un estado.",
  parameterNotADate: "El campo debe ser una fecha.",
  parameterNotANumber: "El campo debe ser un n\u00famero",
  parameterNotFound: "No existe en la base de datos",
  parameterNotInExpectedSet: "El campo no est\u00e1 en el conjunto v\u00e1lido",
  parameterNumberTooLarge: "El valor excede el l\u00edmite superior de %(upper_bound)",
  parameterNumberTooSmall: "El valor es menor al l\u00edmite inferior de %(lower_bound)",
  parameterStringTooLong: "La longitud de la cadena no debe exceder %(max_length) caracteres",
  parameterStringTooShort: "La longitud de la cadena debe ser al menos %(min_length) caracteres",
  parameterUsernameInUse: "El nombre de cuenta no est\u00e1 disponible",
  parentEmailBody: "Ingrese este token para vincular la cuenta de su hijo %(omegaup_url)/user/parentalverification/token/%(parental_verification_token)/",
  parentEmailSubject: "Ficha generada",
  parentalTokenNotFound: "El token parental no fue encontrado",
  parentalTokenVerified: "El token parental ha sido verificado correctamente.",
  passwordAddRequestSuccess: "Se ha agregado tu contrase\u00f1a.",
  passwordCopyToken: "Copiar token",
  passwordGenerateToken: "Generar token",
  passwordGenerateTokenDesc: "Da clic en el bot\u00f3n \"Generar token\" para crear el link",
  passwordHumanReadable: "Generar contrase\u00f1as de f\u00e1cil lectura",
  passwordMismatch: "Las contrase\u00f1as no coinciden.",
  passwordResetLinkCopiedToClipboard: "La liga fue copiada al portapapeles",
  passwordResetMinWait: "Debes esperar unos minutos antes de realizar otra petici\u00f3n.",
  passwordResetPassword: "Nueva contrase\u00f1a",
  passwordResetPasswordConfirmation: "Confirma la nueva contrase\u00f1a",
  passwordResetRequestSuccess: "Instrucciones han sido enviadas a tu correo.",
  passwordResetRequestTitle: "Olvid\u00e9 mi contrase\u00f1a",
  passwordResetResetExpired: "El tiempo para restablecer tu contrase\u00f1a ha expirado.",
  passwordResetResetSuccess: "Tu contrase\u00f1a ha sido actualizada.",
  passwordResetResetTitle: "Restablecer contrase\u00f1a",
  passwordResetTokenWasGeneratedSuccessfully: "El token fue generado exitosamente",
  pendingRegistrations: "Solicitudes pendientes",
  pendingRegistrationsShowAll: "Mostrar todas las solicitudes",
  privacyPolicyNotAccepted: "Por favor lea y acepte la Pol\u00edtica de Uso y Privacidad del sitio, as\u00ed como el C\u00f3digo de Conducta.",
  privacyStatementNotFound: "La declaraci\u00f3n de privacidad no fue encontrada.",
  privateTagsPlaceholder: "Ej. universidad, 2019, clase-2020",
  problemAliasExists: "El alias del problema ya existe, por favor selecciona otro.",
  problemCollectionAuthors: "Autores",
  problemCollectionBackCollections: "\u25c4 Volver a colecciones",
  problemCollectionEducationLevel: "Por nivel educativo",
  problemCollectionOthers: "Otras colecciones",
  problemCollectionProblemCount: "%(count) problemas",
  problemCollectionRandomKarelProblem: "Problema aleatorio de Karel",
  problemCollectionRandomLanguageProblem: "Problema Aleatorio",
  problemCollectionSearchProblem: "Buscador de Problemas",
  problemCraetorGroupDownloadIn: "Guardar .in",
  problemCraetorGroupDownloadTxt: "Guardar .txt",
  problemCreatorAdd: "Agregar",
  problemCreatorAddLine: "Agregar l\u00ednea",
  problemCreatorAutomaticPoints: "Calcular puntaje autom\u00e1ticamente",
  problemCreatorAutomaticPointsHelperCase: "El programa calcular\u00e1 el valor de este caso mediante esta f\u00f3rmula: (puntaje del grupo - (suma de los casos dentro de grupo que tienen puntaje explicito)) / (n\u00famero de casos dentro del grupo sin puntaje explicito)",
  problemCreatorAutomaticPointsHelperGroup: "El programa calcular\u00e1 el valor de este grupo mediante esta f\u00f3rmula: (100 - (suma de los grupos que tienen puntaje explicito)) / (n\u00famero de grupos sin puntaje explicito)",
  problemCreatorAutomaticPointsRecommended: "Calcular puntaje autom\u00e1ticamente (recomendado)",
  problemCreatorCannotHaveSameName: "No puedes tener dos casos/grupos con el mismo nombre",
  problemCreatorCase: "Caso",
  problemCreatorCaseDownloadIn: "Descargar .in",
  problemCreatorCaseDownloadTxt: "Descargar .txt",
  problemCreatorCaseGroupNameHelper: "En min\u00fasculas y sin espacios",
  problemCreatorCaseName: "Nombre del caso",
  problemCreatorCasesTabIntroAddPanelIntro: "Este panel te permite agregar un nuevo caso de prueba.",
  problemCreatorCasesTabIntroAddPanelTitle: "Panel para agregar caso",
  problemCreatorCasesTabIntroSidebarIntro: "Usa esta barra lateral para administrar tus casos de prueba.",
  problemCreatorCasesTabIntroSidebarTitle: "Barra lateral de casos de prueba",
  problemCreatorCode: "C\u00f3digo",
  problemCreatorCodeSave: "Salvar",
  problemCreatorCodeTabIntroSaveCodeIntro: "Una vez que hayas terminado, haz clic aqu\u00ed para guardar los cambios.",
  problemCreatorCodeTabIntroSaveCodeTitle: "Guardar c\u00f3digo",
  problemCreatorCodeTabIntroSelectLanguageIntro: "Elige el lenguaje de programaci\u00f3n para tu c\u00f3digo aqu\u00ed.",
  problemCreatorCodeTabIntroSelectLanguageTitle: "Selecciona un lenguaje",
  problemCreatorCodeTabIntroUploadFileIntro: "Puedes subir un archivo con tu c\u00f3digo en lugar de escribirlo.",
  problemCreatorCodeTabIntroUploadFileTitle: "Subir archivo",
  problemCreatorCodeTabIntroWriteCodeIntro: "Usa el editor de c\u00f3digo para escribir o modificar tu soluci\u00f3n.",
  problemCreatorCodeTabIntroWriteCodeTitle: "Escribe c\u00f3digo",
  problemCreatorCodeUpload: "O sube un archivo",
  problemCreatorCodeUploadFilesize: "El l\u00edmite para subir archivos son %(limit)",
  problemCreatorContentPlaceHolder: "Contenido",
  problemCreatorCreateNewProblem: "Crear nuevo problema",
  problemCreatorCreateNewProblemBack: "Atr\u00e1s",
  problemCreatorCreateNewProblemContinue: "Continuar",
  problemCreatorCreateNewProblemWarning: "\u00bfDeseas comenzar de nuevo? Todos los datos anteriores se perder\u00e1n y el creador se reiniciar\u00e1. Guarda el progreso actual antes de crear uno nuevo. Para hacerlo, haz clic en el bot\u00f3n \"Generar problema\".",
  problemCreatorDeleteCase: "Eliminar caso",
  problemCreatorDeleteCases: "Eliminar casos",
  problemCreatorDeleteGroup: "Eliminar grupo",
  problemCreatorEditCase: "Editar caso",
  problemCreatorEmpty: "",
  problemCreatorEraseOutput: "Borrar salida",
  problemCreatorGenerateProblem: "Generar Problema",
  problemCreatorGroup: "Grupo",
  problemCreatorGroupName: "Nombre del grupo",
  problemCreatorGroups: "Grupos",
  problemCreatorIntroCreateIntro: "Usa este bot\u00f3n para comenzar desde cero y crear un nuevo problema.",
  problemCreatorIntroCreateTitle: "Crear nuevo problema",
  problemCreatorIntroDownloadIntro: "Haz clic aqu\u00ed para descargar tu problema como un archivo .zip cuando est\u00e9 listo.",
  problemCreatorIntroDownloadTitle: "Descargar problema",
  problemCreatorIntroLoadIntro: "Haz clic aqu\u00ed para subir un archivo .zip y cargar un problema existente.",
  problemCreatorIntroLoadTitle: "Cargar problema",
  problemCreatorIntroNameIntro: "Aqu\u00ed puedes ingresar o editar el nombre de tu problema.",
  problemCreatorIntroNameTitle: "Nombre del problema",
  problemCreatorIntroReadyIntro: "\u00a1Eso es todo! Ahora est\u00e1s listo para comenzar a crear problemas. \ud83c\udf89",
  problemCreatorIntroReadyTitle: "\u00a1Listo para crear!",
  problemCreatorIntroWelcomeIntro: "\u00a1Bienvenido al Creador de Problemas! Esta gu\u00eda te mostrar\u00e1 las funciones clave de la interfaz.",
  problemCreatorIntroWelcomeTitle: "\u00a1Bienvenido!",
  problemCreatorIntroWorkspaceIntro: "Esta secci\u00f3n es tu espacio de trabajo para construir un problema. Incluye pesta\u00f1as para escribir el enunciado, agregar c\u00f3digo de soluci\u00f3n, casos de prueba y una soluci\u00f3n oficial.",
  problemCreatorIntroWorkspaceTitle: "Espacio de trabajo",
  problemCreatorLabelPlaceHolder: "Etiqueta",
  problemCreatorLayoutAddFromCase: "Agregar layout del caso seleccionado",
  problemCreatorLayoutAddLineInfo: "Agregar informaci\u00f3n de la l\u00ednea",
  problemCreatorLayoutAddNew: "Agregar nuevo layout",
  problemCreatorLayoutBarClose: "Cerrar barra de layout",
  problemCreatorLayoutCopy: "Hacer una copia",
  problemCreatorLayoutDelete: "Eliminar el layout",
  problemCreatorLayoutLoadToAll: "Cargar en todos los casos",
  problemCreatorLayoutLoadToSelected: "Cargar en el caso seleccionado",
  problemCreatorLayoutNew: "Nuevo layout",
  problemCreatorLayoutWordCopy: " copia",
  problemCreatorLayoutWordLayouts: "Layouts",
  problemCreatorLineArray: "Arreglo",
  problemCreatorLineDelete: "Borrar",
  problemCreatorLineEdit: "Editar",
  problemCreatorLineLine: "L\u00ednea \u00fanica",
  problemCreatorLineMatrix: "Matriz",
  problemCreatorLineMultiline: "Multil\u00edneas",
  problemCreatorLinesDelete: "Eliminar l\u00edneas",
  problemCreatorLinesReorder: "Reordenar",
  problemCreatorLoadProblem: "Cargar Problema",
  problemCreatorMarkdownPreviewInitialRender: "# Previsualizaci\u00f3n\n",
  problemCreatorMarkdownSave: "Salvar",
  problemCreatorMultipleCases: "M\u00faltiples casos",
  problemCreatorName: "Nombre",
  problemCreatorNewProblem: "Nuevo Problema",
  problemCreatorNoGroup: "Sin grupo",
  problemCreatorNumberOfCases: "N\u00famero de casos",
  problemCreatorNumberOfCasesHelper: "Los casos tendr\u00e1n el nombre:",
  problemCreatorOutputPlaceHolder: "Salida",
  problemCreatorPoints: "Puntaje",
  problemCreatorPointsAbbreviation: "pts",
  problemCreatorPrefix: "Prefix",
  problemCreatorRenameLayout: "Renombrar el layout",
  problemCreatorRenameModalBack: "Atr\u00e1s",
  problemCreatorRenameModalRename: "Renombrar",
  problemCreatorRenameModalTitle: "Renombrar el layout",
  problemCreatorSolution: "Soluci\u00f3n",
  problemCreatorSolutionTabIntroEditorIntro: "Escribe tu soluci\u00f3n aqu\u00ed usando la sintaxis de Markdown.",
  problemCreatorSolutionTabIntroEditorTitle: "Editor Markdown",
  problemCreatorSolutionTabIntroPreviewIntro: "Esta secci\u00f3n muestra una vista previa en vivo de tu soluci\u00f3n.",
  problemCreatorSolutionTabIntroPreviewTitle: "Vista previa en vivo",
  problemCreatorSolutionTabIntroSaveIntro: "Haz clic en este bot\u00f3n para guardar el contenido de tu soluci\u00f3n.",
  problemCreatorSolutionTabIntroSaveTitle: "Guardar soluci\u00f3n",
  problemCreatorSolutionTabIntroToolbarIntro: "Usa estos botones para dar formato a tu soluci\u00f3n en Markdown.",
  problemCreatorSolutionTabIntroToolbarTitle: "Barra de herramientas Markdown",
  problemCreatorStatement: "Redacci\u00f3n",
  problemCreatorSuffix: "Sufijo",
  problemCreatorTestCases: "Casos de prueba",
  problemCreatorTitle: "Creador de problemas",
  problemCreatorUngrouped: "Sin_grupo",
  problemCreatorUngroupedCases: "Casos sin grupo",
  problemCreatorUpdateAlert: "El problema se ha actualizado correctamente.",
  problemCreatorUploadZip: "Subir",
  problemCreatorUploadZipMessage: "Sube el archivo zip de tu problema aqu\u00ed.",
  problemCreatorValidatePoints: "Validar y corregir puntos",
  problemCreatorValidatePointsBack: "Atr\u00e1s",
  problemCreatorValidatePointsButton: "Validar puntos",
  problemCreatorValidatePointsContinue: "Continuar",
  problemCreatorValidatePointsWarning: "Los puntos de un grupo deben ser iguales a la suma de los puntos de los casos en \u00e9l. Por favor, contin\u00faa validando y corrigiendo la distribuci\u00f3n de puntos en todos los grupos.",
  problemCreatorZipFileIsNotComplete: "El archivo zip debe contener el archivo cdp.data",
  problemCreatorZipFileIsNotValid: "El archivo subido no es un archivo zip v\u00e1lido",
  problemCreatorZipFileUpload: "Subir archivo zip",
  problemDeployerChangeMissingSettingsJson: "El problema necesita tener un archivo 'settings.json'.",
  problemDeployerConfigBadLayout: "El commit a 'refs/meta/config' tiene una estructura incorrecta.",
  problemDeployerConfigInvalidPublishingMode: "El modo de publicaci\u00f3n elegido no est\u00e1 soportado.",
  problemDeployerConfigRepositoryNotAbsoluteUrl: "El repositorio a ser publicado no es un URL absoluto.",
  problemDeployerConfigSubdirectoryMissingTarget: "El repositorio a ser publicado no tiene un destino en 'target'.",
  problemDeployerEsNoStatement: "No se encontr\u00f3 redacci\u00f3n en espa\u00f1ol.",
  problemDeployerExceededZipSizeLimit: "El tama\u00f1o del .zip despu\u00e9s de descomprimir (%(size) MiB) es mayor al l\u00edmite de (%(max_size) MiB). Rechazando.",
  problemDeployerFailed: "Hubo un error al instalar el problema",
  problemDeployerInteractiveBadLayout: "El problema interactivo no tiene la estructura esperada.",
  problemDeployerInternalError: "Hubo un problema interno al momento de intentar actualizar el problema.",
  problemDeployerInternalGitError: "Hubo un problema de git interno al momento de intentar actualizar el problema.",
  problemDeployerInvalidZipFilename: "La ruta al archivo .zip es inv\u00e1lida.",
  problemDeployerJsonParseError: "Hubo un problema al leer el archivo JSON.",
  problemDeployerLibinteractiveValidationError: "El problema interactivo es inv\u00e1lido",
  problemDeployerMismatchedInputFile: "Hubo al menos un archivo .in sin su .out correspondiente.",
  problemDeployerNoStatements: "No se encontraron redacciones",
  problemDeployerNotAReview: "El merge a la rama 'master' se intent\u00f3 con un commit que no es una revisi\u00f3n.",
  problemDeployerOmegaupUpdateProblemOldVersion: "El problema est\u00e1 siendo migrado a un formato m\u00e1s nuevo. Por favor intenta m\u00e1s tarde.",
  problemDeployerProblemBadLayout: "El problema tiene una estructura inv\u00e1lida.",
  problemDeployerPublishedMustPointToCommitInMaster: "La actualizaci\u00f3n a la rama 'published' deber\u00eda apuntar a un commit en la rama 'master'.",
  problemDeployerReviewBadLayout: "La estructura de la revisi\u00f3n es inv\u00e1lida.",
  problemDeployerSlowRejected: "El problema podr\u00eda correr por m\u00e1s de 5 minutos en caso de TLE. Reduce el n\u00famero de casos o disminuye el tiempo l\u00edmite.",
  problemDeployerTestsBadLayout: "El directorio tests/ tiene una estructura inv\u00e1lida.",
  problemDeployerTooManyObjectsInPackfile: "Hay demasiados objetos en el packfile.",
  problemDeprecated: "El problema est\u00e1 deprecado",
  problemDetailsSource: "Fuente: %(source)",
  problemDownloadZip: "Descargar el archivo zip para el problema",
  problemEditAccess: "Acceso (opcional)",
  problemEditAddAdmin: "Admins",
  problemEditAddTags: "Etiquetas",
  problemEditBasicInfo: "Informaci\u00f3n b\u00e1sica",
  problemEditChooseVersion: "Ver historial de versi\u00f3n",
  problemEditCommitMessage: "Descripci\u00f3n del cambio",
  problemEditDeleteCancel: "Cancelar",
  problemEditDeleteConfirmationMessage: "\u00bfRealmente deseas eliminar el problema?",
  problemEditDeleteOk: "Eliminar",
  problemEditDeleteRequireConfirmation: "Eliminar problema %(problemAlias)",
  problemEditDeleteSelectedProblemsConfirmationMessage: "\u00bfRealmente deseas eliminar los problemas seleccionados?",
  problemEditDeleteSelectedProblemsRequireConfirmation: "Eliminar problemas seleccionados",
  problemEditEditMarkdown: "Editar Redacci\u00f3n",
  problemEditEditProblem: "Ajustes de problema",
  problemEditEmailClarifications: "Recibir preguntas acerca del problema por correo",
  problemEditEvaluation: "Evaluaci\u00f3n (opcional)",
  problemEditFormAllowUserAddTags: "Mostrar los tags sugeridos por coders para este problema",
  problemEditFormAppearsAsPublic: "\u00bfEl problema ser\u00e1 de acceso p\u00fablico?",
  problemEditFormCreateProblem: "Crear problema",
  problemEditFormCustom: "Validador personalizado (validator.$lang$)",
  problemEditFormFile: "Adjuntar archivo zip",
  problemEditFormFirstTimeCreatingAProblem: "\u00bfEs la primera vez que creas un problema?",
  problemEditFormHereIsHowToWriteProblems: "Aqu\u00ed est\u00e1 c\u00f3mo crear el archivo",
  problemEditFormInputLimit: "Tama\u00f1o l\u00edmite de entrada (bytes)",
  problemEditFormLanguages: "Tipo de problema",
  problemEditFormLiteral: "Interpretar salida est\u00e1ndar como puntaje",
  problemEditFormMemoryLimit: "L\u00edmite de memoria (KiB)",
  problemEditFormNumericTokensWithTolerance: "Tokens num\u00e9ricos con tolerancia de 1e-9",
  problemEditFormOutputLimit: "Tama\u00f1o l\u00edmite de salida (bytes)",
  problemEditFormTimeLimit: "Tiempo l\u00edmite de ejecuci\u00f3n por caso (ms)",
  problemEditFormTokenByToken: "Token por Token",
  problemEditFormTokenCaseless: "Token por token, ignorando may\u00fasculas/min\u00fasculas",
  problemEditFormUpdateMarkdown: "Actualizar redacci\u00f3n",
  problemEditFormUpdateProblem: "Actualizar problema",
  problemEditFormUpdateSolution: "Actualizar soluci\u00f3n",
  problemEditFormValidatorTimeLimit: "Tiempo l\u00edmite para el validador (ms)",
  problemEditFormValidatorType: "Tipo de validador de salida",
  problemEditFormWallTimeLimit: "Tiempo l\u00edmite total (ms) (m\u00e1ximo 60000 ms)",
  problemEditGoToProblem: "Ir al problema",
  problemEditGroupScorePolicy: "Puntaje de grupos",
  problemEditGroupScorePolicyMin: "M\u00ednimo",
  problemEditGroupScorePolicySumIfNotZero: "Suma (si todos los casos son no-cero)",
  problemEditLimits: "L\u00edmites (opcional)",
  problemEditSolution: "Editar Soluci\u00f3n",
  problemEditSource: "Fuente del problema",
  problemEditTagPublicRequired: "Es obligatorio seleccionar al menos una etiqueta p\u00fablica y un nivel de problema",
  problemEditTags: "Etiquetas",
  problemEditUpdatedSuccessfully: "Problema actualizado exitosamente.",
  problemEditValidation: "Validaci\u00f3n",
  problemHasBeenUsedInContestOrCourse: "El problema no puede ser eliminado, porque ya fue utilizado en un curso o un concurso",
  problemIsBanned: "Este problema ha sido suspendido.",
  problemIsNotPublic: "El problema no es p\u00fablico y est\u00e1 siendo usado en al menos un concurso activo.",
  problemIsPrivate: "El problema es privado",
  problemLevelAdvancedCompetitiveProgramming: "Nivel Avanzado: Programaci\u00f3n competitiva",
  problemLevelAdvancedSpecializedTopics: "Nivel Avanzado: Temas Especializados",
  problemLevelBasicIntroductionToProgramming: "Nivel B\u00e1sico: Introducci\u00f3n a la programaci\u00f3n",
  problemLevelBasicKarel: "Nivel B\u00e1sico: Karel",
  problemLevelIntermediateAnalysisAndDesignOfAlgorithms: "Nivel Intermedio: An\u00e1lisis y dise\u00f1o de algoritmos",
  problemLevelIntermediateDataStructuresAndAlgorithms: "Nivel Intermedio: Estructuras de datos y Algoritmos",
  problemLevelIntermediateMathsInProgramming: "Nivel Intermedio: Matem\u00e1ticas en la programaci\u00f3n",
  problemLevelUpdated: "El nivel del problema fue actualizado.",
  problemListShowAdminProblems: "Tambi\u00e9n muestra problemas que administro",
  problemListShowAdminProblemsAndDeleted: "Tambi\u00e9n muestra problemas que administro y problemas eliminados",
  problemNew: "Crear problema",
  problemNotFound: "Problema no encontrado",
  problemNotFoundInContest: "Problema no encontrado en concurso",
  problemNotFoundInProblemset: "Problema no encontrado en conjunto de problemas",
  problemNotPartOfAssignment: "El problema no es parte del contenido.",
  problemPrintableVersion: "Obtener la versi\u00f3n imprimible del problema.",
  problemRestrictedTagInteractive: "Interactivo",
  problemRestrictedTagKarel: "Karel",
  problemRestrictedTagLanguage: "Lenguaje",
  problemRestrictedTagNoSubmissions: "Lectura (Sin env\u00edos)",
  problemRestrictedTagOnlyOutput: "Solo salida",
  problemSettingsSummaryTitleWithLetter: "%(letter). %(problem_title)",
  problemSettingsSummaryTitleWithProblemId: "%(problem_id). %(problem_title)",
  problemSettingsSummaryTitleWithProblemsetTitleAndLetter: "%(problemset_title) - %(letter). %(problem_title)",
  problemSolutionNotVisible: "No tienes permiso para ver la soluci\u00f3n del problema. Intenta resolver el problema primero.",
  problemSuccessfullyAdded: "Problema agregado correctamente",
  problemSuccessfullyRemoved: "Problema eliminado correctamente",
  problemSuccessfullyUpdated: "Problema actualizado correctamente",
  problemTagAnalysisOfRecurrences: "An\u00e1lisis de recurrencias",
  problemTagAnalyticGeometry: "Geometr\u00eda anal\u00edtica",
  problemTagArithmetic: "C\u00e1lculos aritm\u00e9ticos",
  problemTagArrays: "Arreglos",
  problemTagBOI: "BOI",
  problemTagBacktracking: "B\u00fasqueda con retroceso",
  problemTagBigData: "Procesamiento de datos masivos",
  problemTagBigNumbers: "N\u00fameros grandes",
  problemTagBinarySearch: "B\u00fasqueda binaria",
  problemTagBinarySearchTree: "\u00c1rboles de b\u00fasqueda binaria",
  problemTagBipartiteMatching: "Acoplamiento bipartito",
  problemTagBitManipulation: "Manipulaci\u00f3n de bits",
  problemTagBooleanAlgebra: "L\u00f3gica y \u00e1lgebra booleana",
  problemTagBreadthFirstSearch: "B\u00fasqueda en amplitud",
  problemTagBruteForce: "Fuerza bruta",
  problemTagCIIC: "CIIC",
  problemTagCOCI: "COCI",
  problemTagCharsAndStrings: "Caracteres y cadenas",
  problemTagChineseRemainderTheorem: "Teorema chino del residuo",
  problemTagCodingCup: "CodingCup",
  problemTagCodingRush: "CodingRush",
  problemTagCombinations: "Combinaciones",
  problemTagCombinatorialDesigns: "Dise\u00f1os combinatorios",
  problemTagConditionals: "Toma de decisiones",
  problemTagConvexHull: "Cerco convexo",
  problemTagCountingProblems: "Problemas de conteo",
  problemTagDataCompression: "Compresi\u00f3n de datos",
  problemTagDepthFirstSearch: "B\u00fasqueda en profundidad",
  problemTagDiophantineEquations: "Ecuaciones diof\u00e1nticas",
  problemTagDirectedGraphs: "Gr\u00e1ficas dirigidas",
  problemTagDisjointSets: "Conjuntos disjuntos",
  problemTagDivideAndConquer: "Divide y vencer\u00e1s",
  problemTagDivisibilityRules: "Reglas de divisibilidad",
  problemTagDynamicProgramming: "Programaci\u00f3n din\u00e1mica",
  problemTagExponentialSearch: "B\u00fasqueda exponencial",
  problemTagExponentiationBySquaring: "Exponenciaci\u00f3n binaria",
  problemTagFenwickTrees: "\u00c1rboles de Fenwick",
  problemTagFileSeeking: "Posicionamiento en archivos",
  problemTagFormattedInputAndOutput: "Entrada y salida con presentaci\u00f3n",
  problemTagFourierTransformation: "Transformada de Fourier",
  problemTagFunctions: "Funciones",
  problemTagGCDAndLCM: "M\u00faltiplos y divisores comunes",
  problemTagGameTheory: "Teor\u00eda de juegos",
  problemTagGeneticAlgorithms: "Algoritmos gen\u00e9ticos",
  problemTagGraphConnectivity: "Conectividad en grafos",
  problemTagGraphRepresentation: "Representaci\u00f3n de grafos",
  problemTagGraphsWithNegativeWeights: "Gr\u00e1ficas con pesos negativos",
  problemTagGreedyAlgorithms: "Algoritmos glotones",
  problemTagHashing: "Dispersi\u00f3n",
  problemTagHeaps: "Mont\u00edculos",
  problemTagHeuristics: "Heur\u00edsticas",
  problemTagICPC: "ICPC",
  problemTagIOI: "IOI",
  problemTagImplementation: "Implementaci\u00f3n",
  problemTagIncrementalSearch: "B\u00fasqueda incremental",
  problemTagInputAndOutput: "Entrada y salida",
  problemTagInvertedIndices: "\u00cdndices invertidos",
  problemTagLazyPropagation: "Evaluaci\u00f3n perezosa",
  problemTagLeastCommonAncestor: "Ancestro com\u00fan en \u00e1rboles",
  problemTagLexingAndParsing: "An\u00e1lisis l\u00e9xico-sint\u00e1ctico",
  problemTagLinearSearch: "B\u00fasqueda lineal",
  problemTagLinkedLists: "Listas enlazadas",
  problemTagLocalSearch: "B\u00fasqueda local",
  problemTagLoops: "Ciclos",
  problemTagMapsMultimaps: "Mapas y multimapas",
  problemTagMatrices: "Matrices",
  problemTagMaxFlow: "Flujo m\u00e1ximo",
  problemTagMeetInTheMiddle: "M\u00e9todo de las dos mitades",
  problemTagMemorization: "Memorizaci\u00f3n",
  problemTagMinimumSpanningTrees: "\u00c1rboles abarcadores m\u00ednimos",
  problemTagModularArithmetic: "Aritm\u00e9tica modular",
  problemTagModularMultiplicativeInverse: "Inverso modular",
  problemTagMonotoneStack: "Pila mon\u00f3tona",
  problemTagNearestNeighbors: "Vecinos m\u00e1s cercanos",
  problemTagNumberTheory: "Teor\u00eda de n\u00fameros",
  problemTagNumericalMethods: "M\u00e9todos num\u00e9ricos",
  problemTagNumericalSeries: "Series num\u00e9ricas",
  problemTagOFMI: "OFMI",
  problemTagOMI: "OMI",
  problemTagOMIAguascalientes: "OMI Aguascalientes",
  problemTagOMIBajaCalifornia: "OMI Baja California",
  problemTagOMIBajaCaliforniaSur: "OMI Baja California Sur",
  problemTagOMICampeche: "OMI Campeche",
  problemTagOMIChiapas: "OMI Chiapas",
  problemTagOMIChihuahua: "OMI Chihuahua",
  problemTagOMICoahuila: "OMI Coahuila",
  problemTagOMIColima: "OMI Colima",
  problemTagOMIDistritoFederal: "OMI Distrito Federal",
  problemTagOMIDurango: "OMI Durango",
  problemTagOMIGuanajuato: "OMI Guanajuato",
  problemTagOMIGuerrero: "OMI Guerrero",
  problemTagOMIHidalgo: "OMI Hidalgo",
  problemTagOMIJalisco: "OMI Jalisco",
  problemTagOMIMexico: "OMI M\u00e9xico",
  problemTagOMIMichoacan: "OMI Michoac\u00e1n",
  problemTagOMIMorelos: "OMI Morelos",
  problemTagOMINayarit: "OMI Nayarit",
  problemTagOMINuevoLeon: "OMI Nuevo Le\u00f3n",
  problemTagOMIOaxaca: "OMI Oaxaca",
  problemTagOMIPS: "OMIPS",
  problemTagOMIPuebla: "OMI Puebla",
  problemTagOMIQueretaro: "OMI Quer\u00e9taro",
  problemTagOMIQuintanaRoo: "OMI Quintana Roo",
  problemTagOMISanLuisPotosi: "OMI San Luis Potos\u00ed",
  problemTagOMISinaloa: "OMI Sinaloa",
  problemTagOMISonora: "OMI Sonora",
  problemTagOMITabasco: "OMI Tabasco",
  problemTagOMITamaulipas: "OMI Tamaulipas",
  problemTagOMITlaxcala: "OMI Tlaxcala",
  problemTagOMIVeracruz: "OMI Veracruz",
  problemTagOMIYucatan: "OMI Yucat\u00e1n",
  problemTagOMIZacatecas: "OMI Zacatecas",
  problemTagOfflineQueries: "Peticiones fuera de l\u00ednea",
  problemTagPalindromeAlgorithms: "Algoritmos de pal\u00edndromos",
  problemTagPartialSums: "Acumulaci\u00f3n parcial",
  problemTagParticleSwarmOptimization: "Optimizaci\u00f3n de part\u00edculas",
  problemTagPermutations: "Permutaciones",
  problemTagPrimalityTest: "Pruebas de primalidad",
  problemTagPrimeFactorization: "Factorizaci\u00f3n prima",
  problemTagPrimeGeneration: "Generaci\u00f3n de primos",
  problemTagProbabilityAndStatistics: "Probabilidad y estad\u00edstica",
  problemTagQueues: "Colas",
  problemTagRecursion: "Recursi\u00f3n",
  problemTagSQRTDecomposition: "Descomposici\u00f3n SQRT",
  problemTagSegmentTrees: "\u00c1rboles de segmentos",
  problemTagSetsMultisets: "Conjuntos y multiconjuntos",
  problemTagShortestPaths: "Caminos m\u00e1s cortos",
  problemTagSimulation: "Simulaci\u00f3n",
  problemTagSlidingWindow: "Ventana deslizante",
  problemTagSorting: "Ordenamiento",
  problemTagStacks: "Pilas",
  problemTagStringMatching: "B\u00fasqueda de subcadenas",
  problemTagSubArraySearch: "B\u00fasqueda de subarreglos",
  problemTagSubsequenceSearch: "B\u00fasqueda de subsecuencias",
  problemTagSuffixTrees: "\u00c1rboles de sufijos",
  problemTagSweepLine: "Barrido del plano",
  problemTagSystemsOfEquations: "Sistemas de ecuaciones",
  problemTagTopologicalSorting: "Ordenamiento topol\u00f3gico",
  problemTagTreeTransversal: "Recorridos en \u00e1rboles",
  problemTagTrees: "\u00c1rboles",
  problemTagTries: "Tries",
  problemTagTwoPointersTechnique: "T\u00e9cnica de dos apuntadores",
  problemTagUnformattedInputAndOutput: "Entrada y salida sin formato",
  problemTagWaveletTrees: "\u00c1rboles Wavelet",
  problemTitleExists: "El t\u00edtulo del problema ya existe, por favor selecciona otro.",
  problemVersionCurrentVersion: "Versi\u00f3n actual",
  problemVersionDate: "Fecha del commit",
  problemVersionDiffMode: "Mostrar diff",
  problemVersionDiffModeFiles: "Archivos",
  problemVersionDiffModeNone: "Ninguno",
  problemVersionDiffModeSubmissions: "Env\u00edos",
  problemVersionMessage: "Mensaje del commit",
  problemVersionNewVersion: "Nueva versi\u00f3n",
  problemVersionNotFound: "Versi\u00f3n del problema no encontrada.",
  problemVersionPublishedRevision: "Publicada",
  problemVersionShowOnlyChanges: "S\u00f3lo mostrar cambios",
  problemVersionUpdate: "Cambiar versi\u00f3n del problema",
  problemVersionUpdatePublishedEditableProblemsets: "Actualizar los concursos / tareas / ex\u00e1menes que administro",
  problemVersionUpdatePublishedNonProblemset: "No actualizar ning\u00fan concurso / tarea / examen",
  problemVersionUpdatePublishedOwnedProblemsets: "Actualizar mis concursos / tareas / ex\u00e1menes",
  problemVersionUpdated: "Versi\u00f3n del problema actualizada.",
  problemVersionUsername: "Nombre de la cuenta",
  problemVersionVersion: "Versi\u00f3n del problema",
  problemcollectionViewProblems: "Ver problemas",
  problemlessGrader: "omegaUp IDE",
  problemsOrderUpdated: "Se actualiz\u00f3 el orden de los problemas",
  problemsetIdentityNotFound: "La cuenta o identidad no est\u00e1 asociada con el curso, concurso o tarea.",
  problemsetNotFound: "Conjunto de problemas no encontrado.",
  profile: "Nombre",
  profileAddIdentitiesTooltip: "Agrega identidades utilizando el nombre de cuenta de omegaUp",
  profileApiTokensEmpty: "No hay tokens de API",
  profileAuthorRank: "Rango de autor",
  profileBasicInformation: "Informaci\u00f3n b\u00e1sica",
  profileContests: "Concursos participados",
  profileContestsTableContest: "Concurso",
  profileContestsTablePlace: "Lugar",
  profileCountry: "Pa\u00eds / Regi\u00f3n",
  profileCreatedContent: "Contenido creado",
  profileCreatedContentSeeAll: "Ver todo",
  profileCreatedContests: "Concursos creados",
  profileCreatedCourses: "Cursos creados",
  profileCreatedProblems: "Problemas creados",
  profileEdit: "Editar perfil",
  profileEmail: "Correo",
  profileGraduationDate: "Fecha de graduaci\u00f3n",
  profileIdentitiesEmpty: "No hay identidades",
  profileIdentityAdded: "Identidad agregada exitosamente",
  profileManageApiTokens: "Administrar claves de la API",
  profileManageIdentities: "Administrar identidades",
  profileName: "Nombre",
  profileOrganizedContests: "Concursos organizados",
  profilePersonalData: "Datos personales",
  profilePrivateRankMessage: "Al activar esta opci\u00f3n, el rango de tu cuenta no ser\u00e1 visible.",
  profilePrivateRankMessageTitle: "Advertencia",
  profileRank: "Rango de coder",
  profileRankBeginner: "\u03bf",
  profileRankExpert: "\u0398",
  profileRankInternationalMaster: "\u03c9",
  profileRankMaster: "\u03a9",
  profileRankSpecialist: "\u039f",
  profileRankUnrated: "Sin clasificaci\u00f3n",
  profileSchool: "Escuela",
  profileSchoolMonthlySolvedProblemsCount: "Total de problemas resueltos mensualmente por los coders de %(school)",
  profileSolvedProblems: "Problemas resueltos",
  profileState: "Estado",
  profileStatistics: "Estad\u00edsticas",
  profileStatisticsCumulative: "Acumulativas",
  profileStatisticsDay: "D\u00eda",
  profileStatisticsDelta: "Delta",
  profileStatisticsMonth: "Mes",
  profileStatisticsNumberOfSolvedProblems: "Cantidad de env\u00edos",
  profileStatisticsPeriod: "Periodo",
  profileStatisticsRuns: "<b>Env\u00edos</b>",
  profileStatisticsTotal: "Total",
  profileStatisticsVerdictsOf: "Veredictos de %(user)",
  profileStatisticsWeek: "Semana",
  profileStatisticsYear: "A\u00f1o",
  profileUnsolvedProblems: "Problemas intentados (pero no resueltos)",
  profileUsername: "Nombre de la cuenta",
  publicCourseCardMetricsLessons: "%(lessonCount) lecciones",
  publicCourseCardMetricsOneLesson: "1 lecci\u00f3n",
  publicCourseCardMetricsOneStudent: "1 estudiante",
  publicCourseCardMetricsStudents: "%(studentCount) estudiantes",
  publicCourseInformationDescription: "Cursos de programaci\u00f3n bajo demanda que omegaUp ofrece de forma gratuita.",
  publicTagsPlaceholder: "Ej. Recursi\u00f3n, \u00c1rboles de segmentos, B\u00fasqueda binaria",
  qualityFormCongrats: "\u00a1Felicidades por resolver este problema!",
  qualityFormDifficulty: "\u00bfQu\u00e9 tan dif\u00edcil te pareci\u00f3 este problema?",
  qualityFormDifficultyAny: "Cualquiera",
  qualityFormDifficultyEasy: "F\u00e1cil",
  qualityFormDifficultyHard: "Dif\u00edcil",
  qualityFormDifficultyMedium: "Medio",
  qualityFormDifficultyVeryEasy: "Muy f\u00e1cil",
  qualityFormDifficultyVeryHard: "Muy dif\u00edcil",
  qualityFormQuality: "\u00bfQu\u00e9 tan bueno te pareci\u00f3 este problema?",
  qualityFormQualityAny: "Cualquier problema",
  qualityFormQualityBad: "Malo",
  qualityFormQualityFair: "Regular",
  qualityFormQualityGood: "Bueno",
  qualityFormQualityOnly: "Solo problemas de calidad",
  qualityFormQualityVeryBad: "Muy malo",
  qualityFormQualityVeryGood: "Muy bueno",
  qualityFormRateBeforeAc: "Ya puedes calificar este problema.",
  qualityFormThanksForReview: "\u00a1Gracias por tus comentarios!",
  qualityNominationCreatedBy: "Creado por",
  qualityNominationMustHaveSolvedProblem: "Debes resolver el problema antes de poder nominarlo",
  qualityNominationMustHaveTriedToSolveProblem: "Debes haber intentado resolver el problema antes de poder nominarlo",
  qualityNominationMustNotHaveSolvedProblem: "No debes haber resuelto el problema para poder enviar una 'nominaci\u00f3n antes de veredicto AC'",
  qualityNominationNominatedBy: "Nominado por",
  qualityNominationNotFound: "Nominaci\u00f3n no encontrada",
  qualityNominationProblemHasBeenBanned: "Este problema ha sido suspendido. No puedes cambiar su visibilidad.",
  qualityNominationProblemHasBeenPromoted: "Este problema ha sido promovido. No puedes cambiar su visibilidad.",
  qualityNominationProblemHasWarning: "Este problema tiene una advertencia. No puedes cambiar su visibilidad.",
  qualityNominationRateProblem: "Calificar el problema",
  qualityNominationRateProblemDesc: "Si quieres calificar el problema m\u00e1s tarde, haz clic en el enlace: \"Calificar el problema\"",
  qualityNominationResolutionSuccess: "Nominaci\u00f3n resuelta exitosamente.",
  qualityNominationShowAll: "Tambi\u00e9n mostrar nominaciones resueltas",
  qualityNominationType: "Tipo",
  rankRangeHeader: "Coders con mayor puntaje (%(lowCount) a %(highCount))",
  rankScore: "Score",
  rankSolved: "Problemas",
  rankingNoUsers: "No tenemos datos para mostrar en la gr\u00e1fica del Ranking.",
  recordNotFound: "Registro no encontrado.",
  registerForContest: "Registrarse en el concurso",
  registerForContestChallenges: "Reto",
  registerForContestRules: "Reglas",
  registerForCourse: "Registrarse en el curso",
  registrationDenied: "Su solicitud de registro ha sido negada",
  registrationPending: "Su solicitud de unirse al concurso est\u00e1 siendo aprobada por el administrador del concurso.",
  registrationPendingCourse: "Su solicitud de unirse al curso est\u00e1 siendo aprobada por el administrador.",
  registrationRejectionFeedback: "La raz\u00f3n proporcionada por administradores del concurso fue: %(extra_note)",
  reportAnIssue: "Reporta un problema",
  reportAnIssueTemplate: "## Comportamiento Esperado\n\n*Describe lo que esperabas que pasara*\n\n## Comportamiento Actual\n\n*Describe lo que pas\u00f3 en lugar de lo que se esperaba*\n\n## Posible Soluci\u00f3n\n\n*No es obligatorio, pero puedes sugerir una manera de arreglar el bug*\n\n## Pasos para reproducir (para bugs)\n\n*Provee un link a un ejemplo, o una lista de pasos detallada de c\u00f3mo reproducir\neste bug.  Incluye el c\u00f3digo que lo reproduce, si es relevante*\n\n1. \n2. \n3. \n4. \n\n## Contexto\n\n*C\u00f3mo te ha afectado este issue? Cu\u00e1l es el objetivo a cumplir?*\n\n*Proveer contexto nos ayuda a encontrar la soluci\u00f3n adecuada*\n\n## Tu ambiente\n\n*Incluye los detalles relevantes acerca del ambiente en el que reprodujiste\neste bug*\n\n* Nombre del navegador (e.g. Chrome 39, node.js 5.4): %(userAgent)\n* Link al sitio en el que este problema pasa: %(referer)\n* Errores en la consola: %(serializedErrors)\n* Captura de pantalla:",
  reportProblemFormAdditionalComments: "Comentarios adicionales (opcional):",
  reportProblemFormCases: "Creo que los casos de prueba est\u00e1n mal.",
  reportProblemFormDuplicate: "Es un problema duplicado.",
  reportProblemFormLinkToOriginalProblem: "Liga al problema original (requerido):",
  reportProblemFormNotAProblemStatement: "No describe un problema de programaci\u00f3n.",
  reportProblemFormOffensive: "Es ofensivo.",
  reportProblemFormOtherReason: "Otra raz\u00f3n.",
  reportProblemFormPoorlyDescribed: "El problema est\u00e1 mal descrito.",
  reportProblemFormQuestion: "\u00bfPor qu\u00e9 quieres reportar este problema?",
  reportProblemFormSpam: "Es Spam.",
  reportProblemFormThanksForReview: "\u00a1Gracias por tu reporte!",
  requestCoder: "Coder",
  requestDate: "Fecha de solicitud",
  requestFeedback: "La solicitud de retroalimentaci\u00f3n ha sido enviada a todos los administradores",
  requestFeedbackConfirm: "\u00bfDeseas solicitar retroalimentaci\u00f3n a tus docentes sobre este env\u00edo?",
  requestFeedbackMessage: "Necesito su ayuda en este env\u00edo.",
  resourceNotFound: "Recurso no encontrado.",
  reviewerNomination: "Calificar el problema como revisor",
  reviewerNominationFormTitle: "Califica este problema.",
  reviewerNominationQuality: "\u00bfEs un problema de calidad?",
  runCannotBeDisqualified: "El env\u00edo no puede ser descalificado.",
  runCannotBeRequalified: "El env\u00edo no puede ser recalificado.",
  runDetailsCompilationError: "Error de compilaci\u00f3n",
  runDetailsCorrect: "Correcta",
  runDetailsExceeded: "L\u00edmite excedido",
  runDetailsFeedbackAddReview: "Agregar comentario",
  runDetailsFeedbackCancel: "Cancelar",
  runDetailsFeedbackPlaceholder: "Escribe tu retroalimentaci\u00f3n aqu\u00ed...",
  runDetailsFeedbackThreadPlaceholder: "Responder...",
  runDetailsFinished: "Terminada",
  runDetailsIncorrect: "Incorrecta",
  runDetailsInterrupted: "Interrumpida",
  runDetailsJudgeError: "Error del juez",
  runDetailsNewFeedback: "Nueva retroalimentaci\u00f3n",
  runDetailsNotAvailable: "No disponible",
  runDetailsRuntimeError: "Error de ejecuci\u00f3n",
  runDetailsRuntimeFunctionError: "Error de funci\u00f3n restringida",
  runDetailsValidatorError: "Error del validador",
  runDisqualifyByProblemConfirm: "\u00bfRealmente desea descalificar todos los env\u00edos del problema en el concurso para este usuario?",
  runDisqualifyByUserConfirm: "\u00bfRealmente desea descalificar todos los env\u00edos del concurso para este usuario?",
  runDisqualifyConfirm: "\u00bfRealmente desea descalificar este env\u00edo?",
  runGUID: "GUID",
  runNotEvenOpened: "Debes abrir el problema antes de intentar enviar una soluci\u00f3n.",
  runNotFound: "run no encontrado",
  runNotInsideContest: "El concurso ya termin\u00f3 o a\u00fan no empieza.",
  runWaitGap: "Debes esperar unos segundos entre env\u00edos consecutivos.",
  schoolNotFound: "Escuela no encontrada",
  schoolNotSelected: "Ninguna escuela seleccionada",
  schoolOfTheMonth: "Escuela del Mes",
  schoolOfTheMonthAlreadySelected: "La escuela del mes ya ha sido seleccionada con anterioridad",
  schoolOfTheMonthChooseAsSchool: "Elegir como Escuela del Mes",
  schoolOfTheMonthIsNotInPeriodToBeChosen: "La escuela del mes no est\u00e1 en periodo de ser elegida",
  schoolOfTheMonthNotFound: "No se encontr\u00f3 escuela del mes.",
  schoolOfTheMonthSelectedSuccessfully: "La Escuela del mes ha sido seleccionada satisfactoriamente.",
  schoolOfTheMonthSystemInMaintainance: "El sistema de Escuela del Mes se encuentra en mantenimiento.\n\nVolveremos pronto.",
  schoolRankOfTheMonthHeader: "Las mejores %(count) escuelas con mayor puntaje del mes",
  schoolRankRangeHeader: "Escuelas con m\u00e1s puntaje (%(lowCount) a %(highCount))",
  schoolUsers: "Coders que pertenecen a esta escuela",
  schoolsCreateCoursesThatMeetNeeds: "Cursos que satisfacen sus necesidades. Puede crear sus propios problemas.",
  schoolsCreateYourCourse: "Cree sus cursos",
  schoolsCreateYourProblems: "Crea tus problemas",
  schoolsLearnProgBySolvProblems: "Aprende programaci\u00f3n solucionando problemas",
  schoolsManageProgressOfStudents: "Administre el progreso de sus estudiantes",
  schoolsOfTheMonth: "Escuelas del Mes",
  schoolsOfTheMonthCandidates: "Candidatas a Escuela del Mes",
  schoolsOfTheMonthRank: "Las mejores 100 escuelas del mes pasado",
  schoolsStartUsingCourses: "Empieza a usar los cursos",
  scoreboardAccountName: "Nombre de la cuenta",
  scoreboardLastUpdated: "\u00daltima vez actualizado: %(datetime)",
  scoreboardNameAndAccountName: "Nombre y nombre de la cuenta",
  scoreboardShowOnlyInvitedIdentities: "Mostrar s\u00f3lo concursantes oficiales",
  scoreboardShowParticipantsNames: "Mostrar nombres de participantes",
  searchUser: "Buscar coder",
  selectProblemLevelDesc: "Para agregar el problema, debes elegir su nivel correspondiente",
  serviceUnavailableError: "Oops. El servicio est\u00e1 actualmente no disponible. Por favor intenta de nuevo m\u00e1s tarde.",
  settingsExtraWallTime: "Tiempo Extra",
  settingsInteractive: "Interactivo",
  settingsLanguage: "Lenguaje de Programaci\u00f3n",
  settingsMemoryLimit: "L\u00edmite de Memoria",
  settingsModuleName: "Nombre del M\u00f3dulo",
  settingsOutputLimit: "L\u00edmite de Salida",
  settingsOverallWallTimeLimit: "L\u00edmite de Tiempo (Total)",
  settingsTimeLimit: "L\u00edmite de Tiempo",
  settingsTolerance: "Tolerancia",
  settingsValidator: "Validador",
  showDefaultAllContestantsInScoreboard: "Mostrar por defecto a todas las personas concursantes en el scoreboard.",
  showLinks: "Enlaces",
  showTotalScoreboard: "Ver scoreboard total",
  signUpFormInteractiveGuideConfirmPassword: "Confirma tu contrase\u00f1a",
  signUpFormInteractiveGuideEmail: "Ingresa tu correo electr\u00f3nico",
  signUpFormInteractiveGuidePassword: "Crea tu contrase\u00f1a, m\u00ednimo 8 caracteres",
  signUpFormInteractiveGuideRegister: "Completa el registro",
  signUpFormInteractiveGuideTermsAndConditions: "Porfavor lea y acepte nuestros t\u00e9rminos y condiciones",
  signUpFormInteractiveGuideTitle: "Crear cuenta",
  signUpFormInteractiveGuideUsername: "Elige el nombre de tu cuenta, S\u00f3lo se permiten letras may\u00fasculas, min\u00fasculas, n\u00fameros y los caracteres _, . y -, el m\u00ednimo de caracteres es 2.",
  signUpFormInteractiveGuideWelcome: "Vamos a crear tu cuenta! \ud83d\udc4b",
  singleUserAddSuccess: "Cuenta exitosamente agregada.",
  socketStatusConnected: "El socket est\u00e1 conectado",
  socketStatusFailed: "La conexi\u00f3n con el socket fall\u00f3",
  socketStatusWaiting: "Esperando conexi\u00f3n con el socket",
  solutionAvailableViews: "Ver vistas disponibles",
  solutionConfirm: "Para ver la soluci\u00f3n de este problema por favor haz clic en el bot\u00f3n siguiente.",
  solutionLocked: "A\u00fan no puedes ver esta soluci\u00f3n.\n\n*   Intenta resolver el problema primero o puedes desbloquearla si a\u00fan no has alcanzado el limite de soluciones vistas por d\u00eda.\n*   Una vez que decidas desbloquear la soluci\u00f3n de un problema, \u00e9ste no contar\u00e1 en tu puntaje en el ranking de omegaUp.",
  solutionNotFound: "A\u00fan no ha sido agregada la soluci\u00f3n para este problema.",
  solutionNotLoggedIn: "Debes iniciar sesi\u00f3n para desbloquear/ver esta soluci\u00f3n.",
  solutionViewsLeft: "Te quedan **%(available)** visualizaciones disponibles, de un total de **%(total)** que puedes realizar por d\u00eda.",
  spinnerLoadingMessage: "Cargando...",
  startContest: "Iniciar concurso",
  startCourse: "Iniciar curso",
  statementLanguage: "Idioma",
  statementLanguageEn: "Ingl\u00e9s",
  statementLanguageEs: "Espa\u00f1ol",
  statementLanguagePt: "Portugu\u00e9s",
  statementNotFound: "Redacci\u00f3n no encontrada",
  studentCourseInformationDescription: "Aqu\u00ed encontrar\u00e1s la lista de los cursos en los que te has inscrito.",
  studentProgressDescriptionTotalPoints: "(%(points) puntos + %(extraPoints) extra)",
  studentProgressExtraProblem: "(extra)",
  studentProgressOnlyLecturesDescription: "Este contenido s\u00f3lo incluye lecturas",
  studentProgressPoints: "(%(points) puntos)",
  studentProgressTooltipDescription: "%(problem):\n\n%(score) de %(points) puntos (%(progress)% de progreso)",
  studentsProgressRangeHeader: "Progreso de los estudiantes (del %(lowCount) al %(highCount))",
  submissionFeedbackAlreadyExists: "Ya existe retroalimentaci\u00f3n para este env\u00edo.",
  submissionFeedbackAnimationButton: "Deja tu retroalimentaci\u00f3n l\u00ednea por l\u00ednea como se muestra en la animaci\u00f3n:",
  submissionFeedbackParticipantsListEmpty: "La lista de participantes en este hilo est\u00e1 vac\u00eda",
  submissionFeedbackSendButton: "Dejar retroalimentaci\u00f3n \ud83d\udd3d",
  submissionMemoryInMegabytes: "%(value) MiB",
  submissionNotFound: "No se encontr\u00f3 el env\u00edo.",
  submissionRunTimeInSeconds: "%(value) s",
  submissionSendFeedback: "Enviar retroalimentaci\u00f3n",
  submissionsListCoder: "Coder",
  submissionsListTitle: "Env\u00edos realizados en las \u00faltimas 24 horas",
  submitFeedbackCancel: "Cancelar",
  submitFeedbackPlaceholder: "Ingresa tus comentarios (opcional)",
  submitFeedbackRequireConfirmation: "Enviar comentarios",
  submitFeedbackSubmit: "Enviar",
  supportAssignUserRoles: "Asignar roles",
  supportContestRemovedFromRecommended: "El concurso ha sido eliminado de recomendados",
  supportContestSetAsRecommended: "El concurso ha sido marcado como recomendado",
  supportNewSearch: "Nueva b\u00fasqueda",
  supportOptions: "Opciones",
  supportSetAsRecommended: "Marcar como recomendado",
  supportTypeContestAlias: "Escribe el alias del concurso",
  supportTypeEmailOrUsername: "Escribe correo electr\u00f3nico o nombre de usuario",
  tagAdded: "Tag agregado exitosamente.",
  tagNotFound: "Etiqueta no encontrada",
  tagPrefixRestricted: "El prefijo 'problemTag' no puede ser usado para las etiquetas agregadas manualmente.",
  tagRemoved: "Tag eliminado exitosamente.",
  tagRestricted: "La etiqueta no puede ser agregada o eliminada.",
  tagSourceLevel: "Nivel",
  tagSourceOwner: "Etiqueta del autor",
  tagSourceVoted: "Etiqueta de coders",
  teamAliasInUse: "Existe al menos un alias de equipo duplicado. Por favor revisa el archivo CSV y corrige la informaci\u00f3n",
  teamMemberExceededNumberOfContestants: "El n\u00famero de concursantes en uno de los equipos supera el m\u00e1ximo permitido",
  teamMemberUsernameInUse: "Existe al menos un nombre de cuenta duplicado en los equipos del grupo. Por favor corrige la informaci\u00f3n.",
  teamsGroupAliasMustBeRequired: "En un concurso para equipos, el alias debe ser requerido.",
  teamsGroupCreateIdentitiesAsTeams: "Crear identidades como equipos",
  teamsGroupCreatingIdentitiesAsTeams: "Creando identidades como equipos",
  teamsGroupEditGroupUpdated: "El grupo de equipos se actualiz\u00f3 correctamente.",
  teamsGroupEditTeams: "Equipos",
  teamsGroupEditTeamsPasswordUpdated: "Contrase\u00f1a actualizada correctamente",
  teamsGroupEditTeamsRemoved: "Equipo eliminado correctamente.",
  teamsGroupEditTeamsUpdated: "Equipo actualizado correctamente.",
  teamsGroupEditTitleWithName: "Editar grupo de equipos %(name)",
  teamsGroupFormCreate: "Crear grupo de equipos",
  teamsGroupFormUpdate: "Actualizar grupo de equipos",
  teamsGroupMemberChangePassword: "Escribe la nueva contrase\u00f1a",
  teamsGroupMembersAccountName: "Nombre de la cuenta",
  teamsGroupNewFormDescription: "Descripci\u00f3n grupo de equipos",
  teamsGroupTeamName: "Nombre de equipo",
  teamsGroupTeamsAdvancedOptions: "Opciones avanzadas",
  teamsGroupTeamsEmptyList: "No hay equipos en este grupo",
  teamsGroupTeamsGroupName: "Nombre de grupo de equipos",
  teamsGroupTeamsSelfGenerateIdentities: "Autogenerar identidades",
  teamsGroupUploadIdentitiesAsTeams: "Cargar equipos",
  teamsGroupUsernames: "Coders",
  teamsGroupsCanNotBeAddedInNormalContest: "No se pueden agregar grupos de equipos en concursos normales",
  teamsGroupsCreateNew: "Crear nuevo grupo de equipos",
  teamsGroupsCsvHelp: "## Agrega r\u00e1pidamente m\u00faltiples identidades como equipo a este grupo. Las identidades no son cuentas normales y no necesitan tener un correo electr\u00f3nico o validar su cuenta.\n\n## Las identidades deben estar en un archivo `.csv` con el siguiente formato:\n```\nusername,name,country_id,state_id,gender,school_name\nteam-1,Team 1,MX,AGU,decline,Best School\nteam-2,Teams 2,MX,AGU,other,Best School\n```",
  teamsGroupsCsvHelpMoreInfo: "\u2139\ufe0f M\u00e1s informaci\u00f3n",
  teamsGroupsErrorFieldIsNotPresentInCsv: "Algunos campos requeridos no fueron encontrados en el archivo csv: %(missingFields)",
  teamsGroupsErrorFieldIsRequired: "El campo %(field) es requerido.",
  titleInUse: "El t\u00edtulo ya est\u00e1 siendo usado. Por favor elige un t\u00edtulo distinto.",
  tokenDecodeCorrupted: "Hubo un problema al decodificar el token.",
  tokenDecodeExpired: "El token que intentas utilizar ha expirado.",
  tokenDecodeInvalid: "El token no pertenece a este curso.",
  tokenDecodeUnknown: "El token no es v\u00e1lido para este curso.",
  totalRuns: "Total de env\u00edos: %(numRuns)",
  typeaheadSearchPlaceholder: "Buscar...",
  unableToVerifyCaptcha: "No fue posible verificar el captcha. Vuelve a cargar la p\u00e1gina e intenta de nuevo.",
  under13UserException: "No puedes acceder a este sitio desde una cuenta para menores de 13 a\u00f1os",
  unnecessaryTokenForPublicCourses: "El token no es necesario para los cursos p\u00fablicos",
  unsupportedBrowser: "Su navegador no admite todas las funciones de esta p\u00e1gina. Intenta actualizar a un <a href=\"https://github.com/omegaup/omegaup#navegadores-soportados\" target=\"blank\">navegador soportado</a>.",
  unverifiedUser: "Cuenta no verificada.",
  updateItemsSuccess: "Todos los items han sido actualizados",
  updateProblemLevel: "Actualizar el nivel del problema",
  updateStatementsCommitMessage: "Actualizando redacciones",
  userAlreadyAcceptedPrivacyPolicy: "Esta cuenta ya hab\u00eda aceptado la pol\u00edtica de privacidad",
  userAlreadyHasSelectedRole: "Esta cuenta ya tiene asignado el rol seleccionado",
  userBirthDate: "Fecha de nacimiento: %(birthDate)",
  userDocsDocumentation: "Documentaci\u00f3n",
  userDoesNotHaveAnyPasswordChangeRequest: "La cuenta no ha realizado la solicitud de cambio de contrase\u00f1a en las \u00faltimas 24 horas.",
  userEditAddPassword: "Agregar contrase\u00f1a",
  userEditBachelors: "Licenciatura",
  userEditBirthDate: "Fecha de nacimiento",
  userEditChangeEmail: "Cambiar correo electr\u00f3nico",
  userEditChangePassword: "Cambiar contrase\u00f1a",
  userEditChangePasswordNewPassword: "Nueva contrase\u00f1a",
  userEditChangePasswordOldPassword: "Contrase\u00f1a anterior",
  userEditChangePasswordRepeatNewPassword: "Repite la contrase\u00f1a de nuevo",
  userEditChangePasswordToUsername: "Cambiar contrase\u00f1a: %(username)",
  userEditCountry: "Pa\u00eds / Regi\u00f3n",
  userEditDeleteAccount: "Eliminar Cuenta",
  userEditDoctorate: "Doctorado",
  userEditEarlyChildhood: "Aprendizaje temprano",
  userEditGraduationDate: "Fecha de graduaci\u00f3n",
  userEditGravatar: "S\u00fabela en Gravatar.com usando tu email: ",
  userEditHideProblemTags: "Ocultar etiquetas de problemas",
  userEditLanguage: "Idioma",
  userEditLowerSecondary: "Secundaria",
  userEditManageSchools: "Administrar escuelas",
  userEditManageSchoolsUserCurrentlyEnrolled: "Actualmente inscrito",
  userEditMaster: "Maestr\u00eda",
  userEditNameTooLong: "El Nombre no puede ser m\u00e1s largo que 50 caracteres.",
  userEditNone: "Ninguna",
  userEditPostSecondary: "Secundaria t\u00e9cnica",
  userEditPrePrimary: "Pre-primaria / K\u00ednder",
  userEditPreferences: "Preferencias",
  userEditPreferencesSuccess: "Preferencias actualizadas correctamente.",
  userEditPreferredProgrammingLanguage: "Lenguaje de programaci\u00f3n de preferencia",
  userEditPrimary: "Primaria",
  userEditPrivateProfile: "\u00bfLe gustar\u00eda ocultar los detalles del perfil de otros?",
  userEditProfileImage: "Imagen de perfil",
  userEditSchoolGrade: "Grado escolar",
  userEditSchoolSuccess: "La informaci\u00f3n de la escuela se actualiz\u00f3 correctamente.",
  userEditSuccess: "Perfil actualizado correctamente",
  userEditSuccessfulEmailUpdate: "Email actualizado correctamente. En unos minutos recibir\u00e1s m\u00e1s instrucciones en tu email. No olvides revisar tu carpeta de Spam.",
  userEditTertiary: "Vocacional",
  userEditUpperSecondary: "Preparatoria",
  userEditViewProfile: "Ver mi perfil",
  userEmailEditEmail: "Email",
  userEmails: "Correos electr\u00f3nicos",
  userEndTimeUpdatedSuccessfully: "El tiempo de finalizaci\u00f3n del concurso se ha actualizado correctamente.",
  userGroups: "Grupos",
  userInformationIsPrivate: "La informaci\u00f3n de esta cuenta es privada",
  userLastLogin: "\u00daltimo inicio de sesi\u00f3n: %(lastLogin)",
  userNeverLoggedIn: "Nunca ha iniciado sesi\u00f3n.",
  userNextRegisteredContestButtonEnter: "Entrar",
  userNextRegisteredContestButtonSeeDetails: "Ver detalles",
  userNextRegisteredContestTitle: "Recuerda participar en el concurso",
  userNotAllowed: "No tienes los permisos para realizar esa acci\u00f3n",
  userNotAllowedToAddPrivateProblem: "Solo los administradores de problemas pueden agregar sus propios problemas privados en el conjunto de problemas",
  userNotExist: "La cuenta no existe",
  userNotInListOfRequests: "Esta cuenta no tiene una solicitud pendiente.",
  userObjectivesModalAnswerCompetitive: "concursos de programaci\u00f3n",
  userObjectivesModalAnswerLearning: "aprender programaci\u00f3n",
  userObjectivesModalAnswerLearningAndTeaching: "aprender y ense\u00f1ar programaci\u00f3n",
  userObjectivesModalAnswerNone: "ninguna de las anteriores",
  userObjectivesModalAnswerOther: "otro",
  userObjectivesModalAnswerScholar: "clases de la escuela",
  userObjectivesModalAnswerScholarAndCompetitive: "clases y concursos",
  userObjectivesModalAnswerTeaching: "ense\u00f1ar programaci\u00f3n",
  userObjectivesModalButtonNext: "Siguiente",
  userObjectivesModalButtonPrevious: "Anterior",
  userObjectivesModalButtonSend: "Enviar",
  userObjectivesModalDescriptionLearning: "Quiero aprender para...",
  userObjectivesModalDescriptionLearningAndTeaching: "Quiero aprender y ense\u00f1ar para...",
  userObjectivesModalDescriptionTeaching: "Quiero ense\u00f1ar para...",
  userObjectivesModalDescriptionUsage: "Quiero usar omegaUp para...",
  userObjectivesModalPageCounter: "%(current) de %(last)",
  userObjectivesModalTitle: "Ay\u00fadanos a conocerte",
  userObjectivesUpdateSuccess: "Gracias por ayudarnos. Tus respuestas han sido guardadas",
  userOrMailNotFound: "Nombre de cuenta o correo electr\u00f3nico no encontrado",
  userPasswordMustBeSame: "Los passwords nuevos deben ser iguales.",
  userProfileIsPrivate: "El perfil de esta cuenta est\u00e1 marcado como privado; alguna informaci\u00f3n no se mostrar\u00e1",
  userProfileProblemsFilter: "Filtrar",
  userRankEmptyList: "No hay datos que mostrar en el ranking",
  userRankLastUpdated: "\u00daltima actualizaci\u00f3n: %(datetime)",
  userRankOfTheMonthHeader: "%(count) coders con mayor puntaje del mes",
  userRankSolvedProblemsHelp: "El n\u00famero de problemas resueltos se actualiza una vez al d\u00eda.",
  userRemoveSuccess: "Cuenta exitosamente eliminada.",
  userRoles: "Roles",
  userVerified: "La cuenta ha sido verificada",
  userVerify: "Verificar cuenta",
  username: "Nombre de cuenta",
  usernameInUse: "Este nombre de cuenta ya ha sido utilizado.",
  usernameOrPassIsWrong: "El nombre de cuenta o la contrase\u00f1a son incorrectos. Por favor verifica tus credenciales.",
  usersCanNotBeAddedInContestForTeams: "No se pueden agregar cuentas individuales en concursos para equipos",
  usersCanNotBeAddedInVirtualContestWhenOriginalContestIsPrivate: "No se puede agregar coders en un concurso virtual cuando el concurso original es privado",
  verdictAC: "Respuesta correcta",
  verdictCE: "Error de compilaci\u00f3n",
  verdictFO: "Error de ejecuci\u00f3n (funci\u00f3n restringida)",
  verdictHelpAC: "\u00a1Tu programa es correcto!",
  verdictHelpCE: "Tu c\u00f3digo fall\u00f3 al compilar. Por favor haz clic en el bot\u00f3n de \"Detalles\" para ver el error de compilaci\u00f3n.",
  verdictHelpDisqualified: "Un juez ha descalificado manualmente tu env\u00edo",
  verdictHelpFO: "Tu programa intent\u00f3 ejecutar una operaci\u00f3n que el sandbox no permite. T\u00edpicamente esto es causado por intentar llamar system().",
  verdictHelpJE: "Ocurri\u00f3 un problema con el juez y no es tu culpa. Alguien ya fue notificado de esto y ser\u00e1 arreglado pronto. Por favor no intentes volver a enviar tu programa porque eso s\u00f3lo va a empeorar las cosas y podr\u00edas ser penalizado.",
  verdictHelpKarelRTE: "Karel choc\u00f3 contra una pared o intent\u00f3 dejar un zumbador con la mochila vac\u00eda.",
  verdictHelpKarelTLE: "Karel se tard\u00f3 demasiado en resolver el problema.",
  verdictHelpML: "Tu programa intent\u00f3 usar m\u00e1s memoria de lo que el problema permite. Intenta pensar en un algoritmo que use menos memoria.",
  verdictHelpMLE: "Tu programa intent\u00f3 usar m\u00e1s memoria de lo que el problema permite. Intenta pensar en un algoritmo que use menos memoria.",
  verdictHelpOL: "Tu programa produjo una respuesta incorrecta en al menos un caso. Como pista, intentaste imprimir demasiado.",
  verdictHelpOLE: "Tu programa produjo una respuesta incorrecta en al menos un caso. Como pista, intentaste imprimir demasiado.",
  verdictHelpPA: "Tu programa resolvi\u00f3 correctamente alguno de los casos, pero produjo una respuesta incorrecta en al menos un caso.",
  verdictHelpRE: "Tu programa termin\u00f3 inesperadamente (crash). Lo m\u00e1s probable es que no consideraste al menos un posible caso de entrada. Esto t\u00edpicamente es causado porque intentaste acceder a un elemento inv\u00e1lido de un arreglo, excediste el tama\u00f1o del stack, o intentaste declarar un arreglo que era demasiado grande.",
  verdictHelpRFE: "Tu programa intent\u00f3 ejecutar una operaci\u00f3n que el sandbox no permite. T\u00edpicamente esto es causado por intentar llamar system().",
  verdictHelpRTE: "Tu programa termin\u00f3 inesperadamente (crash). Lo m\u00e1s probable es que no consideraste al menos un posible caso de entrada. Esto t\u00edpicamente es causado porque intentaste acceder a un elemento inv\u00e1lido de un arreglo, excediste el tama\u00f1o del stack, o intentaste declarar un arreglo que era demasiado grande.",
  verdictHelpTLE: "Tu programa es demasiado lento y no termin\u00f3 antes del tiempo l\u00edmite del problema.",
  verdictHelpTO: "Tu programa es demasiado lento y no termin\u00f3 antes del tiempo l\u00edmite del problema.",
  verdictHelpVE: "Ocurri\u00f3 un problema con el validador de este problema, y puede que sea (o no sea) tu culpa. La mayor\u00eda de las veces esto ocurre porque tu programa hizo algo que el validador no tom\u00f3 en cuenta, pero deber\u00edas de notificar al autor del problema / organizador del concurso de esto.",
  verdictHelpWA: "Tu programa no produjo la respuesta correcta en cada uno de los casos. Lo m\u00e1s probable es que no consideraste todos los posibles casos.",
  verdictJE: "Error del juez (no reenviar)",
  verdictML: "L\u00edmite de memoria excedido",
  verdictMLE: "L\u00edmite de memoria excedido",
  verdictOL: "Respuesta incorrecta (l\u00edmite de salida excedido)",
  verdictOLE: "Respuesta incorrecta (l\u00edmite de salida excedido)",
  verdictPA: "Respuesta parcialmente correcta",
  verdictRE: "Error de ejecuci\u00f3n",
  verdictRFE: "Error de ejecuci\u00f3n (funci\u00f3n restringida)",
  verdictRTE: "Error de ejecuci\u00f3n",
  verdictTLE: "Tiempo l\u00edmite excedido",
  verdictTO: "Tiempo l\u00edmite excedido",
  verdictVE: "Error del validador (no reenviar)",
  verdictWA: "Respuesta incorrecta",
  verificationEmailBody: "\u00a1Bienvenido a omegaUp! Por favor ingresa a la siguiente direcci\u00f3n para hacer login y verificar tu email: <a href=\"https://omegaup.com/user/verifyemail/%(verification_id)/\">https://omegaup.com/user/verifyemail/%(verification_id)/</a>",
  verificationEmailSubject: "\u00a1Bienvenido a omegaUp!",
  verificationEmailSuccessfully: "Tu direcci\u00f3n de correo electr\u00f3nico ha sido verificada.",
  verificationIdInvalid: "La informaci\u00f3n de verificaci\u00f3n suministrada no es v\u00e1lida.",
  verificationParentalTokenGoToMyDependents: "Ir a mis dependientes",
  virtualContest: "Concurso virtual",
  virtualContestSuffix: "%(title) [virtual]",
  virtualSuffix: "%(username) [virtual]",
  virtualTitle: "%(title) - Concurso virtual",
  warningPublicSolution: "Advertencia: El problema que acabas de agregar tiene una soluci\u00f3n p\u00fablica.",
  wizardDescription: "Sigue los pasos para encontrar los problemas que te interesan.",
  wizardLinkText: "Buscador de Problemas",
  wizardPriorityPopularity: "Popularidad",
  wizardStepOne: "Selecciona la(s) etiqueta(s) de los temas",
  wizardStepThree: "Elige tu prioridad",
  wizardStepTwo: "Escoge el rango de dificultad",
  wizardTitle: "Buscador de Problemas",
  wordAccepted: "Aceptado",
  wordsActions: "Acciones",
  wordsAddAdmin: "Agregar admin",
  wordsAddIdentity: "Agregar identidad",
  wordsAddLecture: "Agregar lectura",
  wordsAddMember: "Agregar miembro",
  wordsAddProblem: "Agregar problema",
  wordsAddStudent: "Administrar estudiantes",
  wordsAddStudents: "Agregar estudiantes",
  wordsAddTag: "Agregar Tag",
  wordsAdmin: "Administrador",
  wordsAgree: "Estoy de acuerdo",
  wordsAlias: "Alias",
  wordsAll: "Todos",
  wordsAnswer: "Respuesta",
  wordsAnyLanguage: "Cualquier Lenguaje",
  wordsArchiveCourse: "Archivar curso",
  wordsBack: "Atr\u00e1s",
  wordsBadgesObtained: "Insignias obtenidas",
  wordsBadgesSeeAll: "Ver todas las insignias disponibles",
  wordsBanProblem: "Suspender problema",
  wordsBannedProblem: "Problema suspendido",
  wordsBestSolvers: "Mejores env\u00edos aceptados",
  wordsBy: "por",
  wordsCancel: "Cancelar",
  wordsCase: "Caso",
  wordsCases: "Casos",
  wordsClarifications: "Clarificaciones",
  wordsCloneContest: "Clonar concurso",
  wordsCloneCourse: "Clonar curso",
  wordsCloneThisCourse: "Clonar este curso",
  wordsClose: "Cerrar",
  wordsCode: "Codigo",
  wordsCompilerOutput: "Salida del compilador",
  wordsCompletedPercentage: "Porcentaje completado",
  wordsConfirm: "Confirmar",
  wordsConsole: "Consola",
  wordsContent: "Contenido",
  wordsContentEdit: "Editar contenido",
  wordsContentType: "Tipo de contenido",
  wordsContest: "Concurso",
  wordsContests: "Concursos",
  wordsContestsResults: "Resultados",
  wordsCopyToClipboard: "Copiar en el portapapeles",
  wordsCountry: "Pa\u00eds",
  wordsCountryRegion: "Pa\u00eds / Regi\u00f3n",
  wordsCourseContent: "Contenido del curso",
  wordsDangerZone: "\u00c1rea Peligrosa",
  wordsDangerZoneDesc: "Eliminar el problema.\n\nEsto \u00fanicamente se puede hacer si el problema no ha sido usado en un curso o concurso.\n\nDebes estar muy seguro de querer hacerlo, porque no hay manera de recuperarlo una vez eliminado.",
  wordsDate: "Fecha",
  wordsDelete: "Eliminar",
  wordsDeleted: "Eliminado",
  wordsDenied: "Rechazado",
  wordsDescription: "Descripci\u00f3n",
  wordsDetailed: "Detallado",
  wordsDetails: "Detalles",
  wordsDifference: "Diferencia",
  wordsDifficulty: "Dificultad",
  wordsDownload: "Descargar",
  wordsDownloadCode: "Descargar c\u00f3digo",
  wordsDownloadDetails: "Descargar .zip con salidas",
  wordsDownloadOutput: "Descargar salida",
  wordsDueDate: "Fecha de entrega",
  wordsDuration: "Duraci\u00f3n",
  wordsEdit: "Editar",
  wordsEditCourse: "Editar curso",
  wordsEmpty: "Vac\u00edo",
  wordsEmptyAddStudentInput: "El campo est\u00e1 vac\u00edo, por favor ingrese un nombre de cuenta",
  wordsEnable: "Habilitar",
  wordsEndTime: "Fin",
  wordsEndTimeContest: "Tiempo de finalizaci\u00f3n",
  wordsEnglish: "Ingl\u00e9s",
  wordsExam: "Examen",
  wordsExecution: "Ejecuci\u00f3n",
  wordsExperiments: "Experimentos",
  wordsExtraWallTimeMs: "Tiempo extra para libinteractive (ms)",
  wordsFeedback: "Retroalimentaci\u00f3n de env\u00edos",
  wordsFilterByCountry: "Filtrar por mi pa\u00eds / regi\u00f3n",
  wordsFilterByHomework: "Filtrar por tarea",
  wordsFilterByLanguage: "Filtrar por idioma",
  wordsFilterByProblem: "Filtrar por problema",
  wordsFilterBySchool: "Filtrar por mi escuela",
  wordsFilterByState: "Filtrar por mi estado",
  wordsGender: "G\u00e9nero",
  wordsGenderDecline: "Prefiero no responder",
  wordsGenderFemale: "Femenino",
  wordsGenderMale: "Masculino",
  wordsGenderOther: "Otro",
  wordsGetToKnowOurCourses: "Conoce nuestros cursos",
  wordsGlobalSubmissions: "Env\u00edos globales",
  wordsGroup: "Grupo",
  wordsGroupAdmin: "Grupo de admins",
  wordsGroups: "Grupos",
  wordsHighQualityProblem: "Este problema ha sido reconocido como un Problema de Calidad por un comit\u00e9 de jueces de omegaUp",
  wordsHomework: "Tarea",
  wordsID: "ID",
  wordsIdentities: "Identidades",
  wordsIdentity: "Identidad",
  wordsInOut: "Entrada/Salida",
  wordsInput: "Entrada",
  wordsJudgedBy: "Validado por",
  wordsJustOutput: "Solo Salida",
  wordsKarel: "Karel",
  wordsKeepProblem: "Conservar problema",
  wordsKeyword: "Palabra clave",
  wordsKeywordSearch: "Buscar por alias, t\u00edtulo o id de problema",
  wordsLanguage: "Lenguaje",
  wordsLanguages: "Lenguajes",
  wordsLatestSubmissions: "\u00daltimos env\u00edos",
  wordsLecture: "Lectura",
  wordsLesson: "Lecci\u00f3n",
  wordsLevel: "Nivel",
  wordsLogs: "Bit\u00e1cora de ejecuci\u00f3n",
  wordsMember: "Miembro",
  wordsMemory: "Memoria",
  wordsMemoryInMebibytes: "Memoria (MiB)",
  wordsMessage: "Mensaje",
  wordsMessageTo: "Mensaje para",
  wordsMonths: "Meses",
  wordsMultipleUser: "M\u00faltiples cuentas (separadas por comas o nueva l\u00ednea)",
  wordsMyClarifications: "Mis clarificaciones",
  wordsMyContests: "Mis Concursos",
  wordsMyScore: "Mi puntaje",
  wordsName: "Nombre",
  wordsNewClarification: "Nueva clarificaci\u00f3n",
  wordsNewSubmissions: "Nuevo env\u00edo",
  wordsNext: "Siguiente",
  wordsNextPage: "P\u00e1gina siguiente",
  wordsNo: "No",
  wordsNoComment: "Sin comentarios",
  wordsNoSubmissions: "Lectura (Sin env\u00edos)",
  wordsNone: "Nada",
  wordsNotApplicable: "N/A",
  wordsNumHomeworks: "N\u00famero de tareas",
  wordsNumTests: "N\u00famero de ex\u00e1menes",
  wordsNumberOfContestants: "N\u00famero de concursantes",
  wordsOnlyExamples: "S\u00f3lo ejemplos",
  wordsOptional: "Opcional",
  wordsOther: "Otro",
  wordsOutOf4: "%(Score) de 4",
  wordsOutput: "Salida",
  wordsPenalty: "Tiempo de penalizaci\u00f3n",
  wordsPending: "Pendiente",
  wordsPendingRuns: "Env\u00edos pendientes",
  wordsPercentage: "Porcentaje",
  wordsPoints: "Puntos",
  wordsPointsDistribution: "Distribuci\u00f3n de puntajes del concurso: %(alias)",
  wordsPointsDistributionInIntervals: "Distribuci\u00f3n de puntos en intervalos de 100",
  wordsPointsDistributionProblem: "Distribuci\u00f3n de puntajes del problema: %(alias)",
  wordsPointsForRank: "Puntos para ranking",
  wordsPointsForRankTooltip: "Estos puntos representan el valor actual del problema. Resolver el problema har\u00e1 que valga menos puntos. Para m\u00e1s detalles visita este link.",
  wordsPortuguese: "Portugu\u00e9s",
  wordsPractice: "Pr\u00e1ctica",
  wordsPrevPage: "P\u00e1gina anterior",
  wordsPrevious: "Anterior",
  wordsPrivacyPolicy: "Pol\u00edtica de Privacidad",
  wordsPrivacyPolicyAccepted: "Has aceptado la pol\u00edtica de privacidad",
  wordsPrivate: "Privado",
  wordsPrivateTags: "Etiquetas privadas",
  wordsProblem: "Problema",
  wordsProblemOrSolutionNotExist: "El problema o soluci\u00f3n no existen.",
  wordsProblems: "Problemas",
  wordsProblemsetter: "Subido por",
  wordsProgress: "Progreso",
  wordsProportion: "Proporci\u00f3n",
  wordsPublic: "P\u00fablico",
  wordsPublicTags: "Etiquetas p\u00fablicas",
  wordsPublicUpdated: "Actualizado",
  wordsQuality: "Calidad",
  wordsRanking: "Ranking",
  wordsRankingMeasurement: "\u00bfC\u00f3mo funciona el ranking?",
  wordsRatio: "Ratio",
  wordsReadAgain: "Vuelve a leer",
  wordsReadMore: "Leer m\u00e1s",
  wordsReason: "Raz\u00f3n",
  wordsRegistration: "Registro/abierto",
  wordsRemoveFilter: "Quitar filtros",
  wordsReportProblem: "Reportar problema",
  wordsRequired: "Requerido",
  wordsReset: "omegaUp: Restablecer contrase\u00f1a.",
  wordsResetMessage: "Da clic en el siguiente enlace para restablecer tu contrase\u00f1a: <a href=\"[link]\">[link]</a><br><br>Si tu no solicitaste esta operaci\u00f3n no hagas clic y verifica que tu cuenta este a salvo.",
  wordsResult: "Respuesta",
  wordsReviewingProblem: "Revisando problema",
  wordsRun: "Ejecutar",
  wordsRuns: "Env\u00edos",
  wordsRuntime: "Tiempo",
  wordsSaveChanges: "Guardar cambios",
  wordsSaveNewOrder: "Guardar nuevo orden",
  wordsSchool: "Escuela",
  wordsScore: "Puntaje",
  wordsScoreboard: "Lista de estudiantes",
  wordsSearch: "Buscar",
  wordsSearchBy: "Buscar por",
  wordsSeeCourse: "Ver el curso",
  wordsSeeGeneralRanking: "Ver el ranking general",
  wordsSeeLatestSubmissions: "Ver los \u00faltimos env\u00edos realizados por %(username)",
  wordsSeeSolution: "Ver Soluci\u00f3n",
  wordsSelectFilter: "Selecciona un filtro",
  wordsSend: "Enviar",
  wordsShowCasesDiff: "Mostrar diferencias en los casos",
  wordsShowSiteAdmins: "Mostrar site-admins",
  wordsSource: "Fuente",
  wordsSpanish: "Espa\u00f1ol",
  wordsStart: "Iniciar",
  wordsStartTime: "Inicio",
  wordsStatistics: "Estad\u00edsticas",
  wordsStatus: "Estatus",
  wordsSubmissionDate: "Fecha de env\u00edo",
  wordsSubmissions: "Env\u00edos",
  wordsSubmissionsNotYetReviewed: "Env\u00edos a\u00fan no revisados",
  wordsSubmit: "Enviar",
  wordsSummary: "Resumen",
  wordsTime: "Fecha y hora",
  wordsTimeInSeconds: "Tiempo (Seg)",
  wordsTitle: "T\u00edtulo",
  wordsTotal: "Total",
  wordsTotalVotes: "votos en total",
  wordsUnarchiveCourse: "Desarchivar curso",
  wordsUnlimitedDuration: "Duraci\u00f3n ilimitada",
  wordsUnlockSolution: "Desbloquear Soluci\u00f3n",
  wordsUpdateLecture: "Actualizar lectura",
  wordsUpdateProblem: "Actualizar problema",
  wordsUpload: "Cargar",
  wordsUploadedOn: "Problema subido en: %(date)",
  wordsUsersFeedback: "Opiniones de coders",
  wordsVerdict: "Veredicto",
  wordsVerdictsOf: "Veredictos de %(alias)",
  wordsWallTimeInSeconds: "Tiempo-real (Seg)",
  wordsWarningProblem: "Conservar con una advertencia",
  wordsYes: "S\u00ed",
  zipPrepare: "Preparar archivo zip",
};

export {translations as default};